import React, { Fragment, useState, useEffect, useContext } from 'react';
import * as Survey from 'survey-react';
import './style.css';
import './survey.css';
import {
  Tbody,
  Thead,
  Box,
  Container,
  Stack,
  Text,
  Heading,
  Button,
  Table,
  Tr,
  Th,
  Td,
  Tag,
  TagLabel,
  Center,
  Input,
  FormControl,
  FormLabel,
  Textarea,
  Tooltip,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  Image,
  useToast,
  HStack,
  Progress,
  InputGroup,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useColorModeValue,
  useColorMode,
  Checkbox,
  Link,
  Flex,
  Switch,
  Skeleton,
  Grid,
  GridItem,
  InputLeftAddon,
  Select,
  VStack,
  IconButton,
  Badge,
  RadioGroup,
  Radio,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import './survey.css';
import { Dropzone, FileItem } from '@dropzone-ui/react';
import { FaTrashAlt, FaPencilAlt, FaRegFile, FaSortAmountDown } from 'react-icons/fa';
import { AddIcon, DownloadIcon, CloseIcon, HamburgerIcon, EditIcon, RepeatIcon } from '@chakra-ui/icons';
import AuthContext from '../contexts/AuthContext';

import { useApolloClient, useMutation, useQuery } from '@apollo/client';

import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import renderHTML from 'react-render-html';

import ContentsBySubject from '../graphql/queries/contentsbysubject';
import ContentGroupsBySubject from '../graphql/queries/contentGroupsBySubject';
import ContentsByCodeSlug from '../graphql/queries/contentsByCodeSlug';
import VideoLibrariesPaginated from '../graphql/queries/videoLibrariesPaginated';

import Subject from '../graphql/queries/subject';
import UpdateSubject from '../graphql/mutations/updateSubject';

import ContentMutation from '../graphql/mutations/createContent';
import ContentRemoveMutation from '../graphql/mutations/removeContent';
import UpdateContent from '../graphql/mutations/updateContent';
import CreateContentGroup from '../graphql/mutations/createContentGroup';
import UpdateContentGroup from '../graphql/mutations/updateContentGroup';
import RemoveContentGroup from '../graphql/mutations/removeContentGroup';
import UpdateContentGroupCertificateTemplate from '../graphql/mutations/updateContentGroupCertificateTemplate';
import UpdateVideoLibrary from '../graphql/mutations/updateVideoLibrary';

import { useMultiState } from '../lib/hooks';
import { Link as domlink } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AdapterDayjs from '@mui/lab/AdapterDayjs';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { deepOrange } from '@mui/material/colors';
import DateTimePicker from '@mui/lab/DateTimePicker';
import dayjs from 'dayjs';
import * as tus from 'tus-js-client';
import { TextField } from '@mui/material';
import Iframe from 'react-iframe';
import { useHistory } from 'react-router';

import DialogSortingContent from '../components/pages/ManageContentPage/DialogSortingContent';

import { useTranslation } from 'react-i18next';

const initialContent = {
  name: '',
  carddescription: '',
  link: '',
  text: '',
  type: 'empty',
  description: '',
  date: '',
  statusActive: false,
  public: false,
  codeSlug: '',
  contentGroup: '',
  progressLinkMode: 'none',
};

const initialUpdateContent = {
  name: '',
  link: '',
  text: '',
  type: '',
  description: '',
  duedate: '',
  contentId: '',
  public: false,
  codeSlug: '',
  contentGroup: '',
  progressLinkMode: 'none',
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#0CA25F',
    },
    secondary: deepOrange,
  },
});

const URLImage = process.env.REACT_APP_UPLOAD_IMAGE;
const URLFile = process.env.REACT_APP_UPLOAD_FILE;
// const URLCloudFlare = process.env.REACT_APP_URL_CLOUDFLARE; // No longer used
const URLHomework = process.env.REACT_APP_UPLOAD_HOMEWORK;
const URLVideo = process.env.REACT_APP_UPLOAD_VIDEO;
const ENABLE_PROGRESS_LINK_UX = true;
const VIDEO_SOURCE_LIBRARY = 'library';
const VIDEO_SOURCE_UPLOAD = 'upload';

const CERTIFICATE_IMAGE_GUIDES = {
  logo: {
    minimum: '300 x 300 px',
    recommended: '600 x 600 px',
    maximum: '1,200 x 1,200 px',
    maxFileSize: '2 MB',
    note: 'PNG พื้นหลังโปร่งใส อัตราส่วน 1:1',
  },
  background: {
    minimum: '1,754 x 1,240 px',
    recommended: '3,508 x 2,480 px',
    maximum: '4,961 x 3,508 px',
    maxFileSize: '10 MB',
    note: 'JPG หรือ PNG อัตราส่วน A4 แนวนอน (ประมาณ 1.41:1)',
  },
  signature: {
    minimum: '600 x 200 px',
    recommended: '1,200 x 400 px',
    maximum: '2,400 x 800 px',
    maxFileSize: '2 MB',
    note: 'PNG พื้นหลังโปร่งใส อัตราส่วนประมาณ 3:1',
  },
};

const CertificateImageGuide = ({ type, photo }) => {
  const guide = CERTIFICATE_IMAGE_GUIDES[type];
  const selectedImageSize = photo?.width && photo?.height ? `${photo.width.toLocaleString()} x ${photo.height.toLocaleString()} px` : '';

  return (
    <Box mt={2}>
      <Text fontSize='xs' color='gray.500'>
        ขั้นต่ำ {guide.minimum} · แนะนำ {guide.recommended} · ไม่ควรเกิน {guide.maximum} / {guide.maxFileSize}
      </Text>
      <Text fontSize='xs' color='gray.500'>
        {guide.note}
      </Text>
      {selectedImageSize ? (
        <Text fontSize='xs' color='teal.600' fontWeight='semibold'>
          ไฟล์ที่เลือก: {selectedImageSize} · {((photo?.data?.size || 0) / (1024 * 1024)).toFixed(2)} MB
        </Text>
      ) : null}
    </Box>
  );
};

const getDocumentNameFromUrl = (url = '') => {
  if (!url) return '';

  try {
    return decodeURIComponent(url.split('/').pop().split('?')[0]) || url;
  } catch (error) {
    return url;
  }
};

const ManageContentPage = () => {
  const bg = useColorModeValue('white', 'gray.900');
  const { colorMode } = useColorMode();
  const { user } = useContext(AuthContext);
  const apolloClient = useApolloClient();
  const [refetchList, setRefetchList] = useState(false);
  const [isContentSorting, setIsContentSorting] = useState(false);

  const { isOpen: isUpdateContentOpen, onOpen: onUpdateContentOpen, onClose: onUpdateContentClose } = useDisclosure();
  // const { isOpen: isContentSorting, onOpen: onSortingOpen, onClose: onSortingClose, } = useDisclosure()
  const { isOpen: isPreviewOpen, onOpen: onPreviewOpen, onClose: onPreviewClose } = useDisclosure();
  const { isOpen: isAddContentOpen, onOpen: onAddContentOpen, onClose: onAddContentClose } = useDisclosure();
  const {
    isOpen: isCodeSlugConfirmOpen,
    onOpen: onCodeSlugConfirmOpen,
    onClose: onCodeSlugConfirmClose,
  } = useDisclosure();
  const {
    isOpen: isContentGroupModalOpen,
    onOpen: onContentGroupModalOpen,
    onClose: onContentGroupModalClose,
  } = useDisclosure();
  const {
    isOpen: isContentGroupCertificateOpen,
    onOpen: onContentGroupCertificateOpen,
    onClose: onContentGroupCertificateClose,
  } = useDisclosure();
  const { t } = useTranslation();

  const toast = useToast();
  const history = useHistory();
  const param = useParams();
  // const { user } = useContext(AuthContext)
  const [setUpdateSubject] = useMutation(UpdateSubject);
  const [setUpdateContent] = useMutation(UpdateContent);
  const [removeContentMutation] = useMutation(ContentRemoveMutation);
  const [setContentMutation] = useMutation(ContentMutation);
  const [createContentGroup] = useMutation(CreateContentGroup);
  const [updateContentGroup] = useMutation(UpdateContentGroup);
  const [removeContentGroup] = useMutation(RemoveContentGroup);
  const [updateContentGroupCertificateTemplate] = useMutation(UpdateContentGroupCertificateTemplate);
  const [updateVideoLibrary] = useMutation(UpdateVideoLibrary);

  const [urlCloudFlare, setUrlCloudFlare] = useMultiState({ url: '', id: '' });

  const [editorState, setEditorState] = useState(EditorState?.createEmpty());
  const [editorHomeworkState, seteditorHomeworkState] = useState(EditorState?.createEmpty());
  const [statusDate, setStatusDate] = useState(false);
  const [contentState, setContentState] = useState();
  const [contentData, setContentData] = useMultiState(initialContent);
  const [updateContent, setUpdateContentData] = useMultiState(initialUpdateContent);
  const [sortingState, setSortingState] = useState([]);
  const [preview, setPreview] = useState('');
  const [duration, setDuration] = useState();
  const [videoLibraryKeyword, setVideoLibraryKeyword] = useState('');
  const [videoLibraryPage, setVideoLibraryPage] = useState(1);
  const [videoLibraryEditNames, setVideoLibraryEditNames] = useState({});
  const [videoUploadDisplayName, setVideoUploadDisplayName] = useState('');
  const [videoSourceMode, setVideoSourceMode] = useState(VIDEO_SOURCE_LIBRARY);
  const [updateVideoSourceMode, setUpdateVideoSourceMode] = useState(VIDEO_SOURCE_LIBRARY);
  const [typeDocHomework, setTypeDocHomework] = useState();
  const [contentGroupForm, setContentGroupForm] = useMultiState({
    _id: '',
    name: '',
    description: '',
    index: 0,
    status: 'public',
  });
  const [contentGroupCertificateForm, setContentGroupCertificateForm] = useMultiState({
    _id: '',
    status: false,
    name: '',
    description: '',
    timestatus: 'noset',
    certificatetime: null,
    typesign: 'name',
    firstname: '',
    lastname: '',
    signatureURL: '',
    position: '',
    logoURL: '',
    backgroundURL: '',
  });
  const [codeSlugConfirmState, setCodeSlugConfirmState] = useState({
    action: '',
    relatedContents: [],
    submitter: null,
  });

  const {
    data: Contents,
    loading,
    refetch,
  } = useQuery(ContentsBySubject, {
    variables: {
      subject: param?.subjectId,
    },
  });

  const { data: SubjectData, refetch: reSorting } = useQuery(Subject, {
    variables: {
      _id: param?.subjectId,
    },
  });

  const { data: contentGroupsData, refetch: refetchContentGroups } = useQuery(ContentGroupsBySubject, {
    variables: {
      subject: param?.subjectId,
    },
    fetchPolicy: 'network-only',
  });

  const contentGroups = [...(contentGroupsData?.contentGroups || [])].sort((a, b) => (a.index || 0) - (b.index || 0));

  const { data: videoLibraryData, loading: videoLibraryLoading, refetch: refetchVideoLibraries } = useQuery(VideoLibrariesPaginated, {
    variables: {
      page: videoLibraryPage,
      perPage: 20,
      keyword: videoLibraryKeyword || null,
      sortField: 'mtime',
      sortOrder: -1,
      sync: false,
    },
  });

  const videoLibraryPagination = videoLibraryData?.videoLibrariesPaginated;
  const videoLibraryItems = videoLibraryData?.videoLibrariesPaginated?.items || [];

  const getVideoLibraryDisplayName = (videoItem) => videoItem?.displayName || videoItem?.filename || '';

  const handleVideoLibraryEditNameChange = (videoId, value) => {
    setVideoLibraryEditNames((state) => ({
      ...state,
      [videoId]: value,
    }));
  };

  const handleUpdateVideoLibraryName = async (videoItem) => {
    const displayName = `${videoLibraryEditNames[videoItem?._id] ?? getVideoLibraryDisplayName(videoItem)}`.trim();
    if (!videoItem?._id || !displayName) return;

    await updateVideoLibrary({
      variables: {
        id: videoItem._id,
        displayName,
      },
    });
    await refetchVideoLibraries();
    toast({
      position: 'top',
      title: 'success',
      description: 'บันทึกชื่อวิดีโอแล้ว',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  const renderVideoLibraryItem = (videoItem, isUpdate = false) => {
    const isSelected = (isUpdate ? urlCloudFlare?.url || updateContent?.link : urlCloudFlare?.url) === videoItem?.url;
    const editName = videoLibraryEditNames[videoItem?._id] ?? getVideoLibraryDisplayName(videoItem);

    return (
      <Flex
        key={videoItem?._id}
        justify='space-between'
        align='center'
        p={2}
        borderWidth='1px'
        borderRadius='md'
        mb={2}
        bg={isSelected ? 'green.50' : 'transparent'}
      >
        <Box mr={3} flex='1'>
          <Input
            size='sm'
            value={editName}
            onChange={(e) => handleVideoLibraryEditNameChange(videoItem?._id, e.target.value)}
            mb={1}
          />
          <Text fontSize='xs' color='gray.500' noOfLines={1}>
            {videoItem?.filename}
          </Text>
          <Text fontSize='xs' color='gray.500'>
            {videoItem?.ext} | {Math.floor(Number(videoItem?.duration) || 0)} วินาที
          </Text>
        </Box>
        <HStack spacing={2}>
          <Button size='sm' onClick={() => handleUpdateVideoLibraryName(videoItem)}>
            บันทึกชื่อ
          </Button>
          <Button
            size='sm'
            colorScheme={isSelected ? 'green' : 'gray'}
            onClick={() => handleSelectVideoLibrary(videoItem, isUpdate)}
          >
            {isSelected ? 'เลือกแล้ว' : 'เลือก'}
          </Button>
        </HStack>
      </Flex>
    );
  };

  const handleSelectVideoLibrary = (videoItem, isUpdate = false) => {
    const selectedDuration = Number.isFinite(Number(videoItem?.duration)) ? Math.floor(Number(videoItem?.duration)) : 0;
    if (isUpdate) {
      setUpdateVideoSourceMode(VIDEO_SOURCE_LIBRARY);
    } else {
      setVideoSourceMode(VIDEO_SOURCE_LIBRARY);
    }
    setUrlCloudFlare({
      url: videoItem?.url || '',
      id: videoItem?._id || '',
      file: null,
    });
    setDuration(selectedDuration);
    setFilesVdo([]);
    setUploadStage(0);

    if (isUpdate) {
      setUpdateContentData({
        link: videoItem?.url || '',
        duration: selectedDuration,
      });
    }
  };

  const handleVideoSourceModeChange = (mode, isUpdate = false) => {
    if (isUpdate) {
      setUpdateVideoSourceMode(mode);
    } else {
      setVideoSourceMode(mode);
    }

    setVideoLibraryKeyword('');
    setVideoLibraryPage(1);

    if (mode === VIDEO_SOURCE_LIBRARY) {
      setFilesVdo([]);
      setUploadStage(0);
      setVideoUploadDisplayName('');
      setUrlCloudFlare({ url: '', id: '', file: null });
      setDuration(isUpdate ? updateContent?.duration || 0 : 0);
      return;
    }

    setUrlCloudFlare({ url: '', id: '', file: null });
    setDuration(0);
  };

  const renderVideoLibraryPicker = (isUpdate = false) => (
    <>
      <FormLabel>เลือกจากคลังวิดีโอ</FormLabel>
      <Input
        placeholder='ค้นหาชื่อไฟล์วิดีโอ'
        value={videoLibraryKeyword}
        onChange={(e) => {
          setVideoLibraryKeyword(e.target.value);
          setVideoLibraryPage(1);
        }}
        mb={2}
      />
      <Box borderWidth='1px' borderRadius='lg' p={2} maxH='220px' overflowY='auto' mb={3}>
        {videoLibraryLoading ? (
          <Skeleton height='70px' borderRadius='md' />
        ) : videoLibraryItems?.length ? (
          videoLibraryItems.map((videoItem) => renderVideoLibraryItem(videoItem, isUpdate))
        ) : (
          <Text fontSize='sm' color='gray.500'>
            ไม่พบรายการวิดีโอ
          </Text>
        )}
      </Box>
      <Flex justify='space-between' align='center' mb={3}>
        <Text fontSize='sm' color='gray.500'>
          หน้า {videoLibraryPagination?.page || 1} / {videoLibraryPagination?.totalPages || 1}
        </Text>
        <Flex>
          <Button
            size='sm'
            mr={2}
            onClick={() => setVideoLibraryPage((prev) => Math.max(prev - 1, 1))}
            isDisabled={!videoLibraryPagination?.hasPrevPage}
          >
            Prev
          </Button>
          <Button
            size='sm'
            onClick={() => setVideoLibraryPage((prev) => prev + 1)}
            isDisabled={!videoLibraryPagination?.hasNextPage}
          >
            Next
          </Button>
        </Flex>
      </Flex>
    </>
  );

  const renderVideoUploadPicker = (isUpdate = false) => (
    <>
      <FormControl mb={2}>
        <FormLabel>ชื่อวิดีโอในคลัง</FormLabel>
        <Input
          placeholder='ตั้งชื่อวิดีโอที่จะแสดง'
          value={videoUploadDisplayName}
          onChange={(e) => setVideoUploadDisplayName(e.target.value)}
        />
      </FormControl>
      <Dropzone
        onChange={(incomingFiles) => updateFilesVdo(incomingFiles, isUpdate)}
        value={filesVdo}
        accept='video'
        maxFiles='1'
        view='grid'
      >
        {filesVdo.map((file) => (
          <FileItem
            {...file}
            key={file.id}
            onDelete={onDeleteVdo}
            preview={true}
          />
        ))}
      </Dropzone>
      {urlCloudFlare?.file && (
        <Alert status={urlCloudFlare?.url ? 'success' : 'info'} borderRadius='md' mt={2}>
          <AlertIcon />
          <Text fontSize='sm'>
            {urlCloudFlare?.url ? 'อัปโหลดแล้ว' : 'พร้อมอัปโหลดเมื่อกดบันทึก'}:{' '}
            {filesVdo?.[0]?.file?.name || videoUploadDisplayName || 'วิดีโอใหม่'}
          </Text>
        </Alert>
      )}
      {uploadState === 100 ? (
        <Grid templateColumns='repeat(9, 1fr)' gap={1} py={'2'}>
          <GridItem colSpan={8}>
            <Progress value={uploadState} size='lg' borderRadius={'lg'} colorScheme='green' />
          </GridItem>
          <GridItem colSpan={1} align={'center'}>
            <Text>{`${uploadState} %`}</Text>
          </GridItem>
        </Grid>
      ) : (
        <Grid templateColumns='repeat(9, 1fr)' gap={1} py={'2'}>
          <GridItem colSpan={8}>
            <Progress value={uploadState} hasStripe size='lg' borderRadius={'lg'} />
          </GridItem>
          <GridItem colSpan={1} align={'center'}>
            <Text>{uploadState !== 0 && `${uploadState} %`}</Text>
          </GridItem>
        </Grid>
      )}
    </>
  );

  const renderVideoSourceControls = (isUpdate = false) => {
    const sourceMode = isUpdate ? updateVideoSourceMode : videoSourceMode;

    return (
      <Box>
        <FormControl mb={3}>
          <FormLabel>วิธีเลือกวิดีโอ</FormLabel>
          <RadioGroup value={sourceMode} onChange={(value) => handleVideoSourceModeChange(value, isUpdate)}>
            <HStack spacing={6}>
              <Radio value={VIDEO_SOURCE_LIBRARY}>เลือกจากคลังวิดีโอ</Radio>
              <Radio value={VIDEO_SOURCE_UPLOAD}>อัปโหลดวิดีโอใหม่</Radio>
            </HStack>
          </RadioGroup>
        </FormControl>
        {sourceMode === VIDEO_SOURCE_LIBRARY ? renderVideoLibraryPicker(isUpdate) : renderVideoUploadPicker(isUpdate)}
      </Box>
    );
  };

  const getSortedContents = (contents = [], sorting = []) => {
    const contentList = contents || [];
    if (!Array.isArray(sorting) || sorting.length === 0) return contentList;

    const contentById = new Map(contentList.map((content) => [content?._id, content]));
    const sortedContents = sorting.map((contentId) => contentById.get(contentId)).filter(Boolean);
    const sortedIds = new Set(sortedContents.map((content) => content?._id));
    const unsortedContents = contentList.filter((content) => content?._id && !sortedIds.has(content._id));

    return [...sortedContents, ...unsortedContents];
  };

  const onSortingOpen = () => {
    setIsContentSorting(true);
  };

  const onSortingClose = () => {
    refetch({
      subject: param?.subjectId,
    });
    reSorting({
      subject: param?.subjectId,
    });
    setIsContentSorting(false);
  };

  useEffect(async () => {
    if (user?.role === 'STUDENT') {
      setTimeout(() => {
        history.push('/login');
      }, 100);
    }
    if (Contents) {
      const sortedContents = getSortedContents(Contents?.contents, SubjectData?.subject?.sorting);
      setContentState(sortedContents);
      setSortingState(sortedContents.map((content) => content?._id).filter(Boolean));
    }
    if (localStorage.getItem('refetchPage') !== true) {
      localStorage.setItem('refetchPage', false);
      refetch({
        subject: param?.subjectId,
      });
    }
  }, [history, user, refetch, Contents, contentData, SubjectData]);

  useEffect(async () => {
    try {
      // console.log(list)
      if (refetchList) {
        // console.log("ARRAY", sortingState)
        const { data: Sorting } = await setUpdateSubject({
          variables: {
            _id: param?.subjectId,
            sorting: sortingState,
          },
        });
        if (Sorting) {
          // console.log(QuestionData)
          // await refetch({
          //     subject: param?.subjectId,
          // })
          setRefetchList(false);
          // await toast({
          //     position: 'top',
          //     title: 'Success',
          //     description: `${t('ManageSurveyPage.altsuccesquestion')}`,
          //     status: 'success',
          //     duration: 3000,
          //     isClosable: true,
          // })
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [refetchList, sortingState]);

  const [filesImg, setFilesImg] = useState([]);
  const [filesVdo, setFilesVdo] = useState([]);
  const [filesDoc, setFilesDoc] = useState([]);

  const [newphotoData, setnewphotoData] = useMultiState({
    data: null,
    base64: '',
  });
  const [certificateLogoPhoto, setCertificateLogoPhoto] = useMultiState({
    data: null,
    width: 0,
    height: 0,
  });
  const [certificateBackgroundPhoto, setCertificateBackgroundPhoto] = useMultiState({
    data: null,
    width: 0,
    height: 0,
  });
  const [certificateSignaturePhoto, setCertificateSignaturePhoto] = useMultiState({
    data: null,
    width: 0,
    height: 0,
  });

  const [newDocumentData, setnewDocumentData] = useMultiState({
    data: null,
    base64: '',
    type: '',
  });

  const onDeleteImg = (id) => {
    setFilesImg(filesImg.filter((x) => x.id !== id));
  };

  const onDeleteDoc = (id) => {
    setFilesDoc(filesDoc.filter((x) => x.id !== id));
    setnewDocumentData({ data: null, base64: '', name: '', type: '' });
    setUploadStage(0);
  };

  const onDeleteVdo = (id) => {
    setFilesVdo(filesVdo.filter((x) => x.id !== id));
    setUrlCloudFlare({ url: '', id: '', file: null });
    setDuration(0);
    setUploadStage(0);
  };

  const modalAddContentClose = () => {
    setContentData(initialContent);
    setDuration(0);
    setVideoLibraryKeyword('');
    setVideoLibraryPage(1);
    setVideoSourceMode(VIDEO_SOURCE_LIBRARY);
    setVideoUploadDisplayName('');
    setUrlCloudFlare({ url: '', id: '', file: null });
    setFilesVdo([]);
    setUploadStage(0);
    onAddContentClose();
  };

  const modalAddContentOpen = () => {
    setVideoLibraryKeyword('');
    setVideoLibraryPage(1);
    setVideoSourceMode(VIDEO_SOURCE_LIBRARY);
    setVideoUploadDisplayName('');
    setUrlCloudFlare({ url: '', id: '', file: null });
    setFilesVdo([]);
    setUploadStage(0);
    onAddContentOpen();
  };

  const modalUpdateContentOpen = async (content) => {
    setFilesDoc([]);
    setnewDocumentData({ data: null, base64: '', name: '', type: '' });
    if (content?.type === 'text') {
      setEditorState(
        EditorState?.createWithContent(
          convertFromRaw({
            blocks: content?.texteditor?.blocks,
            entityMap: content?.texteditor?.entityMap,
          }),
        ),
      );
    }
    if (content?.type === 'homework') {
      seteditorHomeworkState(
        EditorState?.createWithContent(
          convertFromRaw({
            blocks: content?.homeworkconfig?.description?.blocks,
            entityMap: content?.homeworkconfig?.description?.entityMap,
          }),
        ),
      );
      setTypeDocHomework(content?.homeworkconfig?.typefile);
    }
    if (content.expiredate) {
      setStatusDate(true);
    }
    setDuration(content?.duration || 0);
    setVideoLibraryKeyword('');
    setVideoLibraryPage(1);
    setUpdateVideoSourceMode(VIDEO_SOURCE_LIBRARY);
    setVideoUploadDisplayName('');
    setUrlCloudFlare({ url: '', id: '', file: null });
    setUploadStage(0);
    setUpdateContentData({
      ...content,
      contentGroup: content?.contentGroup?._id || content?.contentGroup || '',
      progressLinkMode: content?.codeSlug ? 'linked' : 'none',
    });
    onUpdateContentOpen(true);
    refetch({
      subject: param?.subjectId,
    });
  };

  const modalUpdateContentClose = () => {
    setUploadStage(0);
    setDuration(0);
    setVideoLibraryKeyword('');
    setVideoLibraryPage(1);
    setUpdateVideoSourceMode(VIDEO_SOURCE_LIBRARY);
    setVideoUploadDisplayName('');
    setUrlCloudFlare({ url: '', id: '', file: null });
    setFilesVdo([]);
    setFilesDoc([]);
    setnewphotoData({ data: null, base64: '' });
    setnewDocumentData({ data: null, base64: '', name: '', type: '' });
    setUpdateContentData(initialUpdateContent);
    onUpdateContentClose(true);
    refetch({
      subject: param?.subjectId,
    });
  };

  const handlePreviewOpen = (types) => {
    onPreviewOpen(true);
    setUpdateContentData({ type: types });
  };

  const getContentGroupId = (formData) => formData?.contentGroup?._id || formData?.contentGroup || null;

  const getCodeSlugValue = (formData) => {
    if (!ENABLE_PROGRESS_LINK_UX) return `${formData?.codeSlug || ''}`.trim();
    if (formData?.progressLinkMode !== 'linked') return '';
    return `${formData?.codeSlug || ''}`.trim();
  };

  const prepareCodeSlugConfirmation = async ({ action, formData, currentContentId, submitter }) => {
    if (!ENABLE_PROGRESS_LINK_UX) return false;
    const codeSlug = getCodeSlugValue(formData);
    if (!codeSlug) return false;

    const { data } = await apolloClient.query({
      query: ContentsByCodeSlug,
      variables: { codeSlug },
      fetchPolicy: 'network-only',
    });

    const relatedContents = (data?.contents || []).filter((content) => content._id !== currentContentId);
    setCodeSlugConfirmState({ action, relatedContents, submitter });
    onCodeSlugConfirmOpen();
    return true;
  };

  const handleConfirmCodeSlugAndSubmit = async () => {
    const submitter = codeSlugConfirmState.submitter;
    onCodeSlugConfirmClose();
    setCodeSlugConfirmState({ action: '', relatedContents: [], submitter: null });
    if (submitter) await submitter();
  };

  const openCreateContentGroupModal = () => {
    setContentGroupForm({
      _id: '',
      name: '',
      description: '',
      index: contentGroups.length,
      status: 'public',
    });
    onContentGroupModalOpen();
  };

  const openEditContentGroupModal = (group) => {
    setContentGroupForm({
      _id: group?._id,
      name: group?.name || '',
      description: group?.description || '',
      index: group?.index || 0,
      status: group?.status || 'public',
    });
    onContentGroupModalOpen();
  };

  const openContentGroupCertificateModal = (group) => {
    const certificate = group?.certificateconfig || {};
    const signature = certificate.signature || {};
    setCertificateLogoPhoto({ data: null, width: 0, height: 0 });
    setCertificateBackgroundPhoto({ data: null, width: 0, height: 0 });
    setCertificateSignaturePhoto({ data: null, width: 0, height: 0 });
    setContentGroupCertificateForm({
      _id: group?._id,
      status: !!certificate.status,
      name: certificate.name || group?.name || '',
      description: certificate.description || '',
      timestatus: certificate.timestatus || 'noset',
      certificatetime: certificate.certificatetime || null,
      typesign: signature.typesign || 'name',
      firstname: signature.firstname || '',
      lastname: signature.lastname || '',
      signatureURL: signature.signatureURL || '',
      position: certificate.position || '',
      logoURL: certificate.logoURL || '',
      backgroundURL: certificate.backgroundURL || '',
    });
    onContentGroupCertificateOpen();
  };

  const selectContentGroupCertificateImage = (event, formField, setPhotoState) => {
    const file = event.currentTarget.files?.[0];
    if (!file) return;

    setPhotoState({ data: file, width: 0, height: 0 });

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const image = new window.Image();
      image.onload = () => {
        setPhotoState({ width: image.naturalWidth, height: image.naturalHeight });
      };
      image.src = reader.result;

      try {
        const response = await axios.post(URLImage, {
          photo: reader.result,
        });
        setContentGroupCertificateForm({ [formField]: response?.data?.url || '' });
      } catch (error) {
        console.error(error);
        toast({
          position: 'top',
          title: 'warning',
          description: 'อัปโหลดรูปภาพไม่สำเร็จ',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        });
      }
    };
  };

  const handleSubmitContentGroup = async (e) => {
    e.preventDefault();
    if (!contentGroupForm.name) {
      toast({
        position: 'top',
        title: 'Warning',
        description: 'กรุณากรอกชื่อกลุ่มเนื้อหา',
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    if (contentGroupForm._id) {
      await updateContentGroup({
        variables: {
          _id: contentGroupForm._id,
          name: contentGroupForm.name,
          description: contentGroupForm.description,
          index: Number(contentGroupForm.index) || 0,
          status: contentGroupForm.status || 'public',
        },
      });
    } else {
      await createContentGroup({
        variables: {
          subject: param?.subjectId,
          name: contentGroupForm.name,
          description: contentGroupForm.description,
          index: Number(contentGroupForm.index) || 0,
          status: contentGroupForm.status || 'public',
        },
      });
    }

    await refetchContentGroups();
    onContentGroupModalClose();
    toast({
      position: 'top',
      title: 'success',
      description: 'บันทึกกลุ่มเนื้อหาสำเร็จ',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  const handleRemoveContentGroup = async (groupId) => {
    await removeContentGroup({ variables: { _id: groupId } });
    await refetchContentGroups();
    toast({
      position: 'top',
      title: 'success',
      description: 'ลบกลุ่มเนื้อหาแล้ว',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  const handleSubmitContentGroupCertificate = async (e) => {
    e.preventDefault();
    await updateContentGroupCertificateTemplate({
      variables: {
        contentGroupId: contentGroupCertificateForm._id,
        status: !!contentGroupCertificateForm.status,
        name: contentGroupCertificateForm.name,
        description: contentGroupCertificateForm.description,
        timestatus: contentGroupCertificateForm.timestatus,
        certificatetime: contentGroupCertificateForm.certificatetime,
        typesign: contentGroupCertificateForm.typesign,
        firstname: contentGroupCertificateForm.firstname,
        lastname: contentGroupCertificateForm.lastname,
        signatureURL: contentGroupCertificateForm.signatureURL,
        position: contentGroupCertificateForm.position,
        logoURL: contentGroupCertificateForm.logoURL,
        backgroundURL: contentGroupCertificateForm.backgroundURL,
      },
    });
    await refetchContentGroups();
    onContentGroupCertificateClose();
    toast({
      position: 'top',
      title: 'success',
      description: 'บันทึกประกาศนียบัตรของกลุ่มเนื้อหาแล้ว',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  const handleAddContent = async (e, skipCodeSlugConfirm = false) => {
    e.preventDefault();
    if (!skipCodeSlugConfirm) {
      const shouldWaitForConfirm = await prepareCodeSlugConfirmation({
        action: 'add',
        formData: contentData,
        submitter: () => handleAddContent({ preventDefault: () => {} }, true),
      });
      if (shouldWaitForConfirm) return;
    }
    try {
      if (!contentData?.name) {
        await toast({
          position: 'top',
          title: 'Warning',
          description: `${t('AddContentPage.toastAddWarningContent')}`,
          status: 'warning',
          duration: 6000,
          isClosable: true,
        });
      } else if (contentData?.type == 'empty') {
        await toast({
          position: 'top',
          title: 'Warning',
          description: `กรุณาเลือกเนื้อหา`,
          status: 'warning',
          duration: 6000,
          isClosable: true,
        });
      } else {
        if (contentData?.type === 'homework') {
          if (!contentData?.date) {
            await toast({
              position: 'top',
              title: 'Warning',
              description: 'ตั้งค่าวันส่งงาน',
              status: 'warning',
              duration: 6000,
              isClosable: true,
            });
          } else {
            console.log('TYPEFILE::', contentData?.typefile);

            const editordata = convertToRaw(editorHomeworkState.getCurrentContent());
            const responseDocument = await uploadSelectedDocument();
            const { data: responseContent } = await setContentMutation({
              variables: {
                subject: param?.subjectId,
                type: contentData?.type,
                name: contentData?.name,
                carddescription: contentData?.carddescription,
                text: contentData?.text,
                description: editordata,
                duedate: contentData?.date,
                typefile: contentData?.typefile,
                exampleFile: responseDocument ? responseDocument?.data?.url : '',
                exampleFiletype: newDocumentData?.type ? newDocumentData?.type?.toString() : '',
                expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
                statusActive: contentData?.statusActive,
                public: contentData?.public,
                contentGroup: getContentGroupId(contentData),
                codeSlug: getCodeSlugValue(contentData),
              },
            });
            if (responseContent) {
              handlesorting(responseContent?.createContent?.recordId);
              await toast({
                position: 'top',
                title: 'success',
                description: `${t('AddContentPage.toastAddSuccessContent')}`,
                status: 'success',
                duration: 3000,
                isClosable: true,
              });
            }
            setContentData(initialContent);
            setFilesDoc([]);
            setnewDocumentData({ data: null, base64: '', name: '', type: '' });
            refetch({
              subject: param?.subjectId,
            });
            onAddContentClose();
          }
        } else if (contentData?.type === 'photo') {
          const responseImage = await axios.post(URLImage, {
            photo: newphotoData?.base64,
          });

          const { data: responseContent } = await setContentMutation({
            variables: {
              subject: param?.subjectId,
              type: contentData?.type,
              name: contentData?.name,
              carddescription: contentData?.carddescription,
              link: responseImage ? responseImage?.data?.url : '',
              expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
              statusActive: contentData?.statusActive,
              public: contentData?.public,
              contentGroup: getContentGroupId(contentData),
              codeSlug: getCodeSlugValue(contentData),
            },
          });
          if (responseContent) {
            handlesorting(responseContent?.createContent?.recordId);
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('AddContentPage.toastAddSuccessContent')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          }
          setContentData(initialContent);
          setFilesImg([]);
          refetch({
            subject: param?.subjectId,
          });
          onAddContentClose();
        } else if (contentData?.type === 'document') {
          const responseDocument = await uploadSelectedDocument();
          const { data: responseContent } = await setContentMutation({
            variables: {
              subject: param?.subjectId,
              type: contentData?.type,
              name: contentData?.name,
              doctype: newDocumentData?.type ? newDocumentData?.type?.toString() : '',
              carddescription: contentData?.carddescription,
              link: responseDocument ? responseDocument?.data?.url : '',
              expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
              statusActive: contentData?.statusActive,
              public: contentData?.public,
              contentGroup: getContentGroupId(contentData),
              codeSlug: getCodeSlugValue(contentData),
            },
          });
          if (responseContent) {
            handlesorting(responseContent?.createContent?.recordId);
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('AddContentPage.toastAddSuccessContent')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          }
          setContentData(initialContent);
          setFilesDoc([]);
          setnewDocumentData({ data: null, base64: '', name: '', type: '' });
          refetch({
            subject: param?.subjectId,
          });
          onAddContentClose();
        } else if (contentData?.type === 'video') {
          const isUploadMode = videoSourceMode === VIDEO_SOURCE_UPLOAD;
          const selectedVideoFile = filesVdo?.[0]?.file || urlCloudFlare?.file;

          if ((!isUploadMode && !urlCloudFlare?.url) || (isUploadMode && !selectedVideoFile)) {
            await toast({
              position: 'top',
              title: 'Warning',
              description: isUploadMode ? 'กรุณาอัปโหลดวิดีโอใหม่' : 'กรุณาเลือกวิดีโอจากคลัง',
              status: 'warning',
              duration: 6000,
              isClosable: true,
            });
            return;
          }

          const uploadedVideo = isUploadMode ? await uploadSelectedVideo() : null;
          if (isUploadMode && !uploadedVideo?.url) {
            await toast({
              position: 'top',
              title: 'ERROR',
              description: 'อัปโหลดวิดีโอไม่สำเร็จ',
              status: 'error',
              duration: 6000,
              isClosable: true,
            });
            return;
          }
          const selectedVideoUrl = isUploadMode ? uploadedVideo?.url : urlCloudFlare?.url || contentData?.link;
          const selectedDuration = Number.isFinite(Number(isUploadMode ? uploadedVideo?.duration : duration))
            ? Math.floor(Number(isUploadMode ? uploadedVideo?.duration : duration))
            : 0;

          const { data: responseContent } = await setContentMutation({
            variables: {
              subject: param?.subjectId,
              type: contentData?.type,
              name: contentData?.name,
              carddescription: contentData?.carddescription,
              duration: selectedDuration,
              link: selectedVideoUrl,
              expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
              statusActive: contentData?.statusActive,
              public: contentData?.public,
              contentGroup: getContentGroupId(contentData),
              codeSlug: getCodeSlugValue(contentData),
            },
          });
          if (responseContent) {
            handlesorting(responseContent?.createContent?.recordId);
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('AddContentPage.toastAddSuccessContent')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          }
          setContentData(initialContent);
          setDuration(0);
          setVideoUploadDisplayName('');
          setVideoSourceMode(VIDEO_SOURCE_LIBRARY);
          setUrlCloudFlare({ url: '', id: '', file: null });
          setUploadStage(0);
          setFilesVdo([]);
          refetch({
            subject: param?.subjectId,
          });
          onAddContentClose();
        } else if (contentData?.type === 'text') {
          const editordata = convertToRaw(editorState.getCurrentContent());
          const { data: responseContent } = await setContentMutation({
            variables: {
              subject: param?.subjectId,
              type: contentData?.type,
              name: contentData?.name,
              carddescription: contentData?.carddescription,
              texteditor: editordata,
              expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
              statusActive: contentData?.statusActive,
              public: contentData?.public,
              contentGroup: getContentGroupId(contentData),
              codeSlug: getCodeSlugValue(contentData),
            },
          });
          if (responseContent) {
            handlesorting(responseContent?.createContent?.recordId);
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('AddContentPage.toastAddSuccessContent')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          }
          setContentData(initialContent);
          refetch({
            subject: param?.subjectId,
          });
          onAddContentClose();
        } else if (contentData?.type === 'link') {
          // console.log("LINKKKKKKKKKKKKKKKKKKKKKK", param?.subjectId)
          const { data: responseContent } = await setContentMutation({
            variables: {
              subject: param?.subjectId,
              type: contentData?.type,
              name: contentData?.name,
              carddescription: contentData?.carddescription,
              link: contentData?.link,
              expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
              statusActive: contentData?.statusActive,
              public: contentData?.public,
              contentGroup: getContentGroupId(contentData),
              codeSlug: getCodeSlugValue(contentData),
            },
          });
          if (responseContent) {
            handlesorting(responseContent?.createContent?.recordId);
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('AddContentPage.toastAddSuccessContent')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          }
          setContentData(initialContent);
          refetch({
            subject: param?.subjectId,
          });
          onAddContentClose();
        } else if (contentData?.type === 'survey') {
          const editordata = convertToRaw(editorHomeworkState.getCurrentContent());
          const { data: responseContent } = await setContentMutation({
            variables: {
              subject: param?.subjectId,
              type: contentData?.type,
              name: contentData?.name,
              surveydescription: editordata,
              carddescription: contentData?.carddescription,
              expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
              statusActive: contentData?.statusActive,
              public: contentData?.public,
              contentGroup: getContentGroupId(contentData),
              codeSlug: getCodeSlugValue(contentData),
            },
          });
          if (responseContent) {
            handlesorting(responseContent?.createContent?.recordId);
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('AddContentPage.toastAddSuccessContent')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            history.push(`managesurvey/${responseContent?.createContent?.recordId}`);
          }
        } else if (contentData?.type === 'quiz') {
          const { data: responseContent } = await setContentMutation({
            variables: {
              subject: param?.subjectId,
              type: contentData?.type,
              name: contentData?.name,
              carddescription: contentData?.carddescription,
              expiredate: statusDate === true ? dayjs(contentData?.expiredate) : null,
              statusActive: contentData?.statusActive,
              public: contentData?.public,
              contentGroup: getContentGroupId(contentData),
              codeSlug: getCodeSlugValue(contentData),
            },
          });
          if (responseContent) {
            handlesorting(responseContent?.createContent?.recordId);
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('AddContentPage.toastAddSuccessContent')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            history.push(`managequestion/${responseContent?.createContent?.recordId}`);
          }
        }
      }
    } catch (error) {
      console.log(error);
      toast({
        position: 'top',
        title: 'ERROR',
        description: 'error',
        status: 'error',
        duration: 6000,
        isClosable: true,
      });
    }
  };

  const handleUpdateContent = async (e, skipCodeSlugConfirm = false) => {
    e.preventDefault();
    if (!skipCodeSlugConfirm) {
      const shouldWaitForConfirm = await prepareCodeSlugConfirmation({
        action: 'update',
        formData: updateContent,
        currentContentId: updateContent?._id,
        submitter: () => handleUpdateContent({ preventDefault: () => {} }, true),
      });
      if (shouldWaitForConfirm) return;
    }
    try {
      if (!updateContent?.name) {
        await toast({
          position: 'top',
          title: 'Warning',
          description: `${t('managecontentPage.toastAddWarningSubject')}`,
          status: 'warning',
          duration: 6000,
          isClosable: true,
        });
      } else {
        if (updateContent?.type === 'homework') {
          const editordata = convertToRaw(editorHomeworkState.getCurrentContent());
          const responseDocument = await uploadSelectedDocument();
          const { data: ContentAddData } = await setUpdateContent({
            variables: {
              _id: updateContent?._id,
              type: updateContent?.type,
              name: updateContent?.name,
              carddescription: updateContent?.carddescription,
              text: updateContent?.text,
              description: editordata,
              duedate: updateContent?.duedate ? updateContent?.duedate : updateContent?.homeworkconfig?.duedate,
              typefile: typeDocHomework,
              exampleFile: responseDocument?.data?.url || updateContent?.homeworkconfig?.exampleFile || '',
              exampleFiletype:
                getDocumentUploadType() || updateContent?.homeworkconfig?.exampleFiletype || '',
              statusActive: updateContent?.statusActive,
              public: updateContent?.public,
              expiredate: statusDate === true ? dayjs(updateContent.expiredate) : null,
              contentGroup: getContentGroupId(updateContent),
              codeSlug: getCodeSlugValue(updateContent),
            },
          });
          if (ContentAddData) {
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('managecontentPage.toastEditSuccessCourse')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            setUpdateContentData(initialUpdateContent);
            setnewphotoData({ data: null, base64: '' });
            seteditorHomeworkState(EditorState.createEmpty());
            setFilesDoc([]);
            modalUpdateContentClose();
            refetch({
              subject: param?.subjectId,
            });
          }
        } else if (updateContent?.type === 'text') {
          const editordata = convertToRaw(editorState.getCurrentContent());
          const { data: ContentUpdate } = await setUpdateContent({
            variables: {
              _id: updateContent?._id,
              type: updateContent?.type,
              name: updateContent?.name,
              carddescription: updateContent?.carddescription,
              texteditor: editordata,
              statusActive: updateContent?.statusActive,
              public: updateContent?.public,
              contentGroup: getContentGroupId(updateContent),
              codeSlug: getCodeSlugValue(updateContent),
            },
          });
          if (ContentUpdate) {
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('managecontentPage.toastEditSuccessCourse')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            setUpdateContentData(initialUpdateContent);
            setEditorState(EditorState.createEmpty());
            refetch({
              subject: param?.subjectId,
            });
            modalUpdateContentClose();
          }
        } else if (updateContent?.type === 'photo') {
          const responseImage = newphotoData?.base64
            ? await axios.post(URLImage, { photo: newphotoData.base64 })
            : null;
          const { data: ContentUpdate } = await setUpdateContent({
            variables: {
              _id: updateContent?._id,
              type: updateContent?.type,
              name: updateContent?.name,
              carddescription: updateContent?.carddescription,
              link: responseImage?.data?.url || updateContent?.link || '',
              expiredate: statusDate === true ? dayjs(updateContent.expiredate) : null,
              statusActive: updateContent?.statusActive,
              public: updateContent?.public,
              contentGroup: getContentGroupId(updateContent),
              codeSlug: getCodeSlugValue(updateContent),
            },
          });

          if (ContentUpdate) {
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('managecontentPage.toastEditSuccessCourse')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            setUpdateContentData(initialUpdateContent);
            setFilesImg([]);
            refetch({
              subject: param?.subjectId,
            });
            modalUpdateContentClose();
          }
        } else if (updateContent?.type === 'document') {
          const responseDocument = await uploadSelectedDocument();

          const { data: ContentUpdate } = await setUpdateContent({
            variables: {
              _id: updateContent?._id,
              type: updateContent?.type,
              name: updateContent?.name,
              doctype: getDocumentUploadType() || updateContent?.doctype || '',
              carddescription: updateContent?.carddescription,
              link: responseDocument?.data?.url || updateContent?.link || '',
              expiredate: statusDate === true ? dayjs(updateContent.expiredate) : null,
              statusActive: updateContent?.statusActive,
              public: updateContent?.public,
              contentGroup: getContentGroupId(updateContent),
              codeSlug: getCodeSlugValue(updateContent),
            },
          });

          if (ContentUpdate) {
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('managecontentPage.toastEditSuccessCourse')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            setUpdateContentData(initialUpdateContent);
            setFilesDoc([]);
            setnewDocumentData({ data: null, base64: '', name: '', type: '' });
            refetch({
              subject: param?.subjectId,
            });
            modalUpdateContentClose();
          }
        } else if (updateContent?.type === 'video') {
          const isUploadMode = updateVideoSourceMode === VIDEO_SOURCE_UPLOAD;
          const selectedVideoFile = filesVdo?.[0]?.file || urlCloudFlare?.file;

          if (isUploadMode && !selectedVideoFile) {
            await toast({
              position: 'top',
              title: 'Warning',
              description: 'กรุณาอัปโหลดวิดีโอใหม่',
              status: 'warning',
              duration: 6000,
              isClosable: true,
            });
            return;
          }

          const uploadedVideo = isUploadMode ? await uploadSelectedVideo() : null;
          if (isUploadMode && !uploadedVideo?.url) {
            await toast({
              position: 'top',
              title: 'ERROR',
              description: 'อัปโหลดวิดีโอไม่สำเร็จ',
              status: 'error',
              duration: 6000,
              isClosable: true,
            });
            return;
          }
          const selectedVideoUrl = isUploadMode ? uploadedVideo?.url : urlCloudFlare?.url || updateContent?.link;
          const selectedDuration = Number.isFinite(Number(isUploadMode ? uploadedVideo?.duration : duration))
            ? Math.floor(Number(isUploadMode ? uploadedVideo?.duration : duration))
            : Number.isFinite(Number(updateContent?.duration))
              ? Math.floor(Number(updateContent?.duration))
              : 0;

          if (!selectedVideoUrl) {
            await toast({
              position: 'top',
              title: 'Warning',
              description: isUploadMode ? 'กรุณาอัปโหลดวิดีโอใหม่' : 'กรุณาเลือกวิดีโอจากคลัง',
              status: 'warning',
              duration: 6000,
              isClosable: true,
            });
            return;
          }

          const { data: ContentUpdate } = await setUpdateContent({
            variables: {
              _id: updateContent?._id,
              type: updateContent?.type,
              name: updateContent?.name,
              carddescription: updateContent?.carddescription,
              duration: selectedDuration,
              link: selectedVideoUrl,
              expiredate: statusDate === true ? dayjs(updateContent.expiredate) : null,
              statusActive: updateContent?.statusActive,
              public: updateContent?.public,
              contentGroup: getContentGroupId(updateContent),
              codeSlug: getCodeSlugValue(updateContent),
            },
          });
          if (ContentUpdate) {
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('managecontentPage.toastEditSuccessCourse')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });

            modalUpdateContentClose();
            setFilesVdo([]);
            setVideoUploadDisplayName('');
            setUpdateVideoSourceMode(VIDEO_SOURCE_LIBRARY);
            refetch({
              subject: param?.subjectId,
            });
          }
        } else if (updateContent?.type === 'link') {
          const { data: ContentUpdate } = await setUpdateContent({
            variables: {
              _id: updateContent?._id,
              type: updateContent?.type,
              name: updateContent?.name,
              carddescription: updateContent?.carddescription,
              link: updateContent?.link,
              expiredate: statusDate === true ? dayjs(updateContent.expiredate) : null,
              statusActive: updateContent?.statusActive,
              public: updateContent?.public,
              contentGroup: getContentGroupId(updateContent),
              codeSlug: getCodeSlugValue(updateContent),
            },
          });

          if (ContentUpdate) {
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('managecontentPage.toastEditSuccessCourse')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            setUpdateContentData(initialUpdateContent);
            modalUpdateContentClose();
            refetch({
              subject: param?.subjectId,
            });
          }
        } else {
          const { data: ContentAddData } = await setUpdateContent({
            variables: {
              _id: updateContent?._id,
              type: updateContent?.type,
              name: updateContent?.name,
              carddescription: updateContent?.carddescription,
              text: updateContent?.text,
              expiredate: statusDate === true ? dayjs(updateContent.expiredate) : null,
              statusActive: updateContent?.statusActive,
              public: updateContent?.public,
              contentGroup: getContentGroupId(updateContent),
              codeSlug: getCodeSlugValue(updateContent),
            },
          });

          // console.log(ContentAddData)
          if (ContentAddData) {
            await toast({
              position: 'top',
              title: 'success',
              description: `${t('managecontentPage.toastEditSuccessCourse')}`,
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
            setUpdateContentData(initialUpdateContent);
            setnewphotoData({ data: null, base64: '' });
            setnewDocumentData({ data: null, base64: '', name: '', type: '' });
            setFilesImg([]);
            setFilesDoc([]);
            modalUpdateContentClose();
          }
        }
      }
    } catch (error) {
      console.error(error);
      setUpdateContentData(initialUpdateContent);
      setnewphotoData({ data: null, base64: '' });
      setnewDocumentData({ data: null, base64: '', name: '', type: '' });
      setFilesImg([]);
      setFilesDoc([]);
      modalUpdateContentClose();
      toast({
        position: 'top',
        title: 'ERROR',
        description: 'error',
        status: 'error',
        duration: 6000,
        isClosable: true,
      });
    }
  };

  const updateFilesImg = (incommingFiles, e) => {
    if (incommingFiles.length !== 0) {
      new Promise((resolve, reject) => {
        setFilesImg(incommingFiles);
        setnewphotoData({ data: incommingFiles[0]?.file });
        const reader = new FileReader();
        reader.readAsDataURL(incommingFiles[0]?.file);
        reader.onload = () => {
          resolve(reader.result);
          setnewphotoData({
            base64: reader.result,
          });
        };
        reader.onerror = (error) => reject(error);
      });
    }
  };

  const updateFilesDoc = (incommingFiles, e) => {
    if (incommingFiles.length !== 0) {
      const regex = /[^.]+$/g;
      const documentFile = incommingFiles[0]?.file;
      const typefile = documentFile?.name.match(regex);
      setFilesDoc(incommingFiles);
      setnewDocumentData({
        data: documentFile,
        base64: '',
        type: typefile ? typefile[0].toLowerCase() : '',
      });
      setUploadStage(0);
    }
  };

  const [uploadState, setUploadStage] = useState(0);

  const getDocumentUploadType = () => {
    const documentType = newDocumentData?.type;
    if (Array.isArray(documentType)) return `${documentType[0] || ''}`.toLowerCase();
    if (documentType) return `${documentType}`.replace('.', '').toLowerCase();
    return `${newDocumentData?.data?.name?.split('.').pop() || ''}`.toLowerCase();
  };

  const uploadSelectedDocument = async () => {
    const documentFile = newDocumentData?.data;
    const documentType = getDocumentUploadType();

    if (documentFile) {
      const formData = new FormData();
      formData.append('file', documentFile);
      formData.append('type', documentType);

      return axios.post(URLFile, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentage = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            setUploadStage(percentage);
          }
        },
      });
    }

    if (newDocumentData?.base64) {
      return axios.post(URLFile, {
        file: newDocumentData?.base64,
        type: documentType,
      });
    }

    return null;
  };

  const updateFilesVdo = async (incomingFiles, isUpdate = false) => {
    setFilesVdo(incomingFiles);
    setUploadStage(0);
    if (isUpdate) {
      setUpdateVideoSourceMode(VIDEO_SOURCE_UPLOAD);
    } else {
      setVideoSourceMode(VIDEO_SOURCE_UPLOAD);
    }
    const videoInputFile = incomingFiles[0]?.file;
    if (!videoInputFile) return;

    const computedDuration = await getVideoDuration(incomingFiles);
    const normalizedDuration = Number.isFinite(computedDuration) ? Math.floor(computedDuration) : 0;

    setUrlCloudFlare({
      url: '',
      id: '',
      file: videoInputFile,
    });
    setDuration(normalizedDuration);
  };

  const uploadSelectedVideo = async () => {
    const videoInputFile = filesVdo?.[0]?.file || urlCloudFlare?.file;
    if (!videoInputFile) return null;

    const regex = /[^.]+$/g;
    const typefile = videoInputFile.name.match(regex);
    const normalizedDuration = Number.isFinite(Number(duration)) ? Math.floor(Number(duration)) : 0;
    const formData = new FormData();
    formData.append('file', videoInputFile);
    formData.append('type', typefile ? typefile[0].toLowerCase() : 'mp4');
    formData.append('duration', String(normalizedDuration));
    formData.append('displayName', videoUploadDisplayName.trim() || contentData?.name || updateContent?.name || videoInputFile.name);

    const response = await axios.post(URLVideo, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        setUploadStage(percentage);
      },
    });

    if (response.data?.url) {
      setUrlCloudFlare({ url: response.data.url, id: '', file: videoInputFile });
      const uploadedDuration = Number(response.data.duration) || normalizedDuration;
      setDuration(uploadedDuration);
      setVideoLibraryKeyword('');
      setVideoLibraryPage(1);
      await refetchVideoLibraries({
        page: 1,
        perPage: 20,
        keyword: null,
        sortField: 'mtime',
        sortOrder: -1,
        sync: false,
      });
      return {
        url: response.data.url,
        duration: uploadedDuration,
      };
    }

    return null;
  };

  //Alert dialog remove content
  const [showRemoveContent, setShowRemoveContent] = useState(false);
  const [removeContentIndex, setRemoveContentIndex] = useState('');

  const handleOpenRemoveContent = (content) => {
    setRemoveContentIndex(content);
    setShowRemoveContent(true);
  };

  const handleCloseRemoveContent = () => {
    setShowRemoveContent(false);
  };

  const handleRemoveContent = async (e) => {
    e.preventDefault();
    try {
      // console.log(removeContentIndex)
      const { data: subjectremovedata } = await removeContentMutation({
        variables: {
          _id: removeContentIndex?._id,
        },
      });
      if (subjectremovedata) {
        handleRemoveSorting(removeContentIndex?._id);
        await toast({
          position: 'top',
          title: 'success',
          description: `${t('managecontentPage.toastRemoveSuccess')}`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        refetch({
          subject: param?.subjectId,
        });
        setRemoveContentIndex('');
        handleCloseRemoveContent();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleConvertHTML = (text) => {
    if (text) {
      return renderHTML(draftToHtml(text));
    }
    return '';
  };

  const handlesorting = async (content_id) => {
    try {
      const nextSortingState = Array.from(new Set([...(sortingState || []), content_id].filter(Boolean)));
      const { data: Sorting } = await setUpdateSubject({
        variables: {
          _id: param?.subjectId,
          name: SubjectData?.subject?.name,
          sorting: nextSortingState,
        },
      });
      reSorting({
        subject: param?.subjectId,
      });
      setSortingState(nextSortingState);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemoveSorting = async (content_id) => {
    try {
      var newArray = (sortingState || []).filter(function (f) {
        return f !== content_id;
      });
      // console.log(newArray)
      const { data: Sorting, errors: streamErr } = await setUpdateSubject({
        variables: {
          _id: param?.subjectId,
          sorting: newArray,
        },
      });
      reSorting({
        subject: param?.subjectId,
      });
      setSortingState([]);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRefetchContent = () => {
    reSorting({
      subject: param?.subjectId,
    });
    refetch({
      subject: param?.subjectId,
    });
  };

  const getVideoDuration = (filesVdo) => {
    return new Promise((resolve, reject) => {
      // e.preventDefault();
      var file = filesVdo[0]?.file, // selected file
        mime = file?.type, // store mime for later
        reader = new FileReader(); // create a FileReader

      reader.onload = (e) => {
        // when file has read:

        var blob = new Blob([file], { type: mime }), // create a blob of buffer
          url = (URL || window.webkitURL).createObjectURL(blob), // create o-URL of blob
          video = document.createElement('video'); // create video element

        video.preload = 'metadata'; // preload setting
        video.addEventListener('loadedmetadata', function () {
          // when enough data loads
          // console.log("DDDD22222", video.duration)
          const durationInSeconds = Math.floor(video.duration || 0);
          (URL || window.webkitURL).revokeObjectURL(url);
          resolve(durationInSeconds);
          setDuration(durationInSeconds);
        });
        video.src = url; // start video load
      };
      reader.readAsArrayBuffer(file);
      reader.onerror = (error) => reject(error);
    });
  };

  const certificateAwardDate =
    contentGroupCertificateForm?.timestatus === 'set' && contentGroupCertificateForm?.certificatetime
      ? dayjs(contentGroupCertificateForm.certificatetime).format('DD/MM/YYYY')
      : 'วันที่ออกใบประกาศ';
  const contentGroupCertificatePreviewHtml = `<!doctype html>
    <html lang="en-US">
    <head>
      <meta content="text/html; charset=utf-8" http-equiv="Content-Type" />
      <title>Certificate</title>
      <link href="https://fonts.googleapis.com/css?family=Satisfy" rel="stylesheet">
      <style type="text/css">
        @media print { html, body { margin: 0; } }
        html, body { margin: 0; }
        .cert {
          border: 13px solid #0072c6 !important;
          border-right: 13px solid #0894fb;
          border-left: 13px solid #0894fb;
          width: ${isContentGroupCertificateOpen ? '174mm' : '28cm'};
          height: ${isContentGroupCertificateOpen ? '94mm' : '10cm'};
          font-family: arial;
          color: ${colorMode === 'light' ? '#383737' : 'white'};
          background-image: url(${contentGroupCertificateForm?.backgroundURL || 'https://ppi-course.com/images/5.png'});
          background-repeat: no-repeat;
          background-size: cover;
          size: A4 landscape;
          margin: 0;
        }
        .crt_title {
          margin-top: 20px;
          font-family: "Satisfy", cursive;
          font-size: 40px;
          letter-spacing: 1px;
          color: #0060a9;
        }
        .crt_logo img {
          width: 130px;
          height: auto;
          margin: auto;
          padding: 10px;
        }
        .colorGreen { color: #27ae60; }
        .crt_user {
          display: inline-block;
          width: 80%;
          padding: 5px 25px 0;
          margin-bottom: 0;
          font-family: "Satisfy", cursive;
          font-size: 40px;
          border-bottom: 1px dashed #cecece;
        }
        .afterName {
          font-weight: 100;
          color: ${colorMode === 'light' ? '#383737' : 'white'};
        }
        .certSign { width: 200px; max-height: 80px; object-fit: contain; }
      </style>
    </head>
    <body>
      <table class="cert">
        <tr>
          <td align="center" class="crt_logo">
            ${contentGroupCertificateForm?.logoURL ? `<img src="${contentGroupCertificateForm.logoURL}" alt="logo"/>` : ''}
          </td>
        </tr>
        <tr>
          <td align="center">
            <h1 class="crt_title">Certificate Of Completion</h1>
            <h2>This Certificate is awarded to</h2>
            <h1 class="colorGreen crt_user">Sohrab Zia</h1>
            <h3 class="afterName">For his/her completion of ${contentGroupCertificateForm?.name || 'Content Group'}</h3>
            ${contentGroupCertificateForm?.description ? `<h3>${contentGroupCertificateForm.description}</h3>` : ''}
            <h3>Awarded on ${certificateAwardDate}</h3>
          </td>
        </tr>
        <tr>
          <td align="center">
            ${
              contentGroupCertificateForm?.typesign === 'signature' && contentGroupCertificateForm?.signatureURL
                ? `<img src="${contentGroupCertificateForm.signatureURL}" class="certSign" alt="sign" />`
                : `<h3 style="font-style: italic;" class="certSign">${contentGroupCertificateForm?.firstname || '-'} ${
                    contentGroupCertificateForm?.lastname || ''
                  }</h3>`
            }
            <h3>(${contentGroupCertificateForm?.firstname || '-'} ${contentGroupCertificateForm?.lastname || ''})</h3>
            <h3>${contentGroupCertificateForm?.position || ''}</h3>
          </td>
        </tr>
      </table>
    </body>
    </html>`;

  console.log(typeDocHomework, 'SSSSSSS');

  return (
    <Fragment>
      <Modal isOpen={isCodeSlugConfirmOpen} onClose={onCodeSlugConfirmClose} size='xl'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ยืนยันการเชื่อมความคืบหน้า</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Alert status='warning' mb={4} borderRadius='md'>
              <AlertIcon />
              รหัสนี้มีผลกับการคำนวณ % ของรายวิชา เพราะระบบจะเชื่อม progress ของเนื้อหาที่ใช้ codeSlug เดียวกัน
            </Alert>
            {codeSlugConfirmState.relatedContents.length > 0 ? (
              <VStack align='stretch' spacing={2}>
                <Text fontWeight='bold'>รหัสนี้กำลังเชื่อมกับเนื้อหาต่อไปนี้</Text>
                {codeSlugConfirmState.relatedContents.map((content) => (
                  <Box key={content._id} borderWidth='1px' borderRadius='md' p={3}>
                    <Text fontWeight='semibold'>{content.name}</Text>
                    <Text fontSize='sm' color='gray.500'>
                      รายวิชา: {content.subject?.name || '-'}
                    </Text>
                  </Box>
                ))}
              </VStack>
            ) : (
              <Text>ยังไม่พบเนื้อหาอื่นที่ใช้รหัสนี้ ระบบจะเริ่มสร้างการเชื่อม progress ด้วยรหัสนี้</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onCodeSlugConfirmClose}>
              ยกเลิก
            </Button>
            <Button colorScheme='teal' onClick={handleConfirmCodeSlugAndSubmit}>
              ยืนยันและบันทึก
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isContentGroupModalOpen} onClose={onContentGroupModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{contentGroupForm._id ? 'แก้ไขกลุ่มเนื้อหา' : 'เพิ่มกลุ่มเนื้อหา'}</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleSubmitContentGroup}>
            <ModalBody>
              <VStack spacing={4} align='stretch'>
                <FormControl>
                  <FormLabel>ชื่อกลุ่มเนื้อหา</FormLabel>
                  <Input value={contentGroupForm.name} onChange={(e) => setContentGroupForm({ name: e.target.value })} />
                </FormControl>
                <FormControl>
                  <FormLabel>รายละเอียด</FormLabel>
                  <Textarea
                    value={contentGroupForm.description}
                    onChange={(e) => setContentGroupForm({ description: e.target.value })}
                  />
                </FormControl>
                <HStack>
                  <FormControl>
                    <FormLabel>ลำดับ</FormLabel>
                    <Input
                      type='number'
                      value={contentGroupForm.index}
                      onChange={(e) => setContentGroupForm({ index: e.target.value })}
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>สถานะ</FormLabel>
                    <Select value={contentGroupForm.status} onChange={(e) => setContentGroupForm({ status: e.target.value })}>
                      <option value='public'>เปิดใช้งาน</option>
                      <option value='unpublic'>ปิดใช้งาน</option>
                    </Select>
                  </FormControl>
                </HStack>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={onContentGroupModalClose}>
                ยกเลิก
              </Button>
              <Button colorScheme='teal' type='submit'>
                บันทึก
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      <Modal isOpen={isContentGroupCertificateOpen} onClose={onContentGroupCertificateClose} size='6xl'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ตั้งค่าประกาศนียบัตรของกลุ่มเนื้อหา</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleSubmitContentGroupCertificate}>
            <ModalBody>
              <Stack direction={['column', 'column', 'column', 'row']} spacing='24px'>
                <Box
                  mt='10'
                  borderWidth='2px'
                  borderRadius='lg'
                  p={1}
                  alignSelf='center'
                  sx={{
                    color: colorMode === 'light' ? 'black !important' : 'white !important',
                    overflowX: ['auto', 'auto', 'none'],
                    maxW: ['90%', '400px', '90%', 'none'],
                    maxH: ['250px', '250px', '90%', 'none'],
                  }}
                >
                  {renderHTML(contentGroupCertificatePreviewHtml)}
                </Box>
                <Box py='10px' mt='25px' p='5' minW={{ base: '100%', lg: '390px' }}>
                  <Stack spacing={4}>
                    <FormControl display='flex' alignItems='center'>
                      <FormLabel mb='0'>เปิดใช้งานประกาศนียบัตร</FormLabel>
                      <Switch
                        isChecked={!!contentGroupCertificateForm.status}
                        onChange={(e) => setContentGroupCertificateForm({ status: e.target.checked })}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>ชื่อบนประกาศนียบัตร</FormLabel>
                      <Input
                        value={contentGroupCertificateForm.name}
                        onChange={(e) => setContentGroupCertificateForm({ name: e.target.value })}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>รายละเอียด</FormLabel>
                      <Textarea
                        value={contentGroupCertificateForm.description}
                        onChange={(e) => setContentGroupCertificateForm({ description: e.target.value })}
                      />
                    </FormControl>
                    <FormControl id='content-group-certificate-logo'>
                      <FormLabel>{t('managecertificatePage.logo')}</FormLabel>
                      <HStack>
                        <Button size='sm' as='label'>
                          {t('Button.edit')}
                          <input
                            onChange={(e) => selectContentGroupCertificateImage(e, 'logoURL', setCertificateLogoPhoto)}
                            accept='image/*'
                            type='file'
                            style={{ display: 'none' }}
                          />
                        </Button>
                        <Text noOfLines={1}>{certificateLogoPhoto?.data?.name}</Text>
                      </HStack>
                      <CertificateImageGuide type='logo' photo={certificateLogoPhoto} />
                    </FormControl>
                    <FormControl id='content-group-certificate-background'>
                      <FormLabel>{t('managecertificatePage.background')}</FormLabel>
                      <HStack>
                        <Button size='sm' as='label'>
                          {t('Button.edit')}
                          <input
                            onChange={(e) => selectContentGroupCertificateImage(e, 'backgroundURL', setCertificateBackgroundPhoto)}
                            accept='image/*'
                            type='file'
                            style={{ display: 'none' }}
                          />
                        </Button>
                        <Text noOfLines={1}>{certificateBackgroundPhoto?.data?.name}</Text>
                      </HStack>
                      <CertificateImageGuide type='background' photo={certificateBackgroundPhoto} />
                    </FormControl>
                    <FormControl as='fieldset'>
                      <FormLabel as='legend'>{t('managecertificatePage.signature_style')}</FormLabel>
                      <RadioGroup
                        value={contentGroupCertificateForm.typesign}
                        onChange={(value) => setContentGroupCertificateForm({ typesign: value })}
                      >
                        <HStack spacing='24px'>
                          <Radio value='signature'>{t('managecertificatePage.signature')}</Radio>
                          <Radio value='name'>{t('managecertificatePage.name_surname')}</Radio>
                        </HStack>
                      </RadioGroup>
                    </FormControl>
                    {contentGroupCertificateForm.typesign === 'signature' ? (
                      <FormControl id='content-group-certificate-signature'>
                        <FormLabel>{t('managecertificatePage.signature_image')}</FormLabel>
                        <HStack>
                          <Button size='sm' as='label'>
                            {t('Button.edit')}
                            <input
                              onChange={(e) => selectContentGroupCertificateImage(e, 'signatureURL', setCertificateSignaturePhoto)}
                              accept='image/*'
                              type='file'
                              style={{ display: 'none' }}
                            />
                          </Button>
                          <Text noOfLines={1}>{certificateSignaturePhoto?.data?.name}</Text>
                        </HStack>
                        <CertificateImageGuide type='signature' photo={certificateSignaturePhoto} />
                      </FormControl>
                    ) : null}
                    <HStack>
                      <FormControl>
                        <FormLabel>Firstname / ชื่อ</FormLabel>
                        <Input
                          value={contentGroupCertificateForm.firstname}
                          onChange={(e) => setContentGroupCertificateForm({ firstname: e.target.value })}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Lastname / สกุล</FormLabel>
                        <Input
                          value={contentGroupCertificateForm.lastname}
                          onChange={(e) => setContentGroupCertificateForm({ lastname: e.target.value })}
                        />
                      </FormControl>
                    </HStack>
                    <FormControl>
                      <FormLabel>{t('managecertificatePage.position')}</FormLabel>
                      <Input
                        placeholder='กรอกตำแหน่ง'
                        value={contentGroupCertificateForm.position}
                        onChange={(e) => setContentGroupCertificateForm({ position: e.target.value })}
                      />
                    </FormControl>
                    <FormControl as='fieldset'>
                      <FormLabel as='legend'>{t('managecertificatePage.set_time_certificate')}</FormLabel>
                      <RadioGroup
                        value={contentGroupCertificateForm.timestatus}
                        onChange={(value) => setContentGroupCertificateForm({ timestatus: value })}
                      >
                        <HStack spacing='24px'>
                          <Radio value='set'>{t('managecertificatePage.set_time')}</Radio>
                          <Radio value='noset'>{t('managecertificatePage.current_time')}</Radio>
                        </HStack>
                      </RadioGroup>
                    </FormControl>
                    {contentGroupCertificateForm.timestatus === 'set' ? (
                      <FormControl>
                        <ThemeProvider theme={theme}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              label={t('managecertificatePage.date')}
                              value={contentGroupCertificateForm.certificatetime ? contentGroupCertificateForm.certificatetime : ''}
                              onChange={(value) => setContentGroupCertificateForm({ certificatetime: value })}
                              renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                            />
                          </LocalizationProvider>
                        </ThemeProvider>
                      </FormControl>
                    ) : null}
                  </Stack>
                </Box>
              </Stack>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={onContentGroupCertificateClose}>
                ยกเลิก
              </Button>
              <Button colorScheme='teal' type='submit'>
                บันทึก
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      {/* //UPDATECONTENT */}
      <Modal isOpen={isUpdateContentOpen} onClose={modalUpdateContentClose} style={{ zIndex: 1 }} size={'5xl'}>
        {console.log('UPDATE', updateContent)}
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('managecontentPage.editContent')}</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleUpdateContent} style={{ zIndex: 2 }}>
            <ModalBody>
              <Box maxW='7xl' mx={'auto'} px={{ base: 2, sm: 12, md: 17 }}>
                <Grid
                  boxShadow={'xl'}
                  templateRows='repeat(1, 1fr)'
                  templateColumns='repeat(5, 1fr)'
                  borderRadius='lg'
                  borderWidth={'1px'}
                >
                  <GridItem rowSpan={1} colSpan={1} bg={'primary.900'} borderLeftRadius='lg'>
                    <Center pt={5}>
                      <Stack>
                        <Flex
                          boxShadow={'dark-lg'}
                          borderWidth='5px'
                          borderColor={'primary.800'}
                          w={14}
                          h={14}
                          align={'center'}
                          justify={'center'}
                          color={'primary.900'}
                          rounded={'full'}
                          bg={'white'}
                          mb={1}
                        >
                          <Text fontSize={'18px'} as='samp'>
                            {'1'}
                          </Text>
                        </Flex>
                      </Stack>
                    </Center>
                  </GridItem>
                  <GridItem colSpan={4}>
                    <InputGroup p={'2'}>
                      <Input
                        boxShadow={'md'}
                        borderWidth='1px'
                        placeholder={t('AddContentPage.contentname')}
                        _placeholder={{
                          opacity: 1,
                          color: colorMode == 'light' ? 'gray.500' : 'white',
                        }}
                        value={updateContent?.name}
                        onChange={(e) => {
                          setUpdateContentData({ name: e.target.value });
                        }}
                      />
                    </InputGroup>
                    <InputGroup p={'2'}>
                      <Input
                        boxShadow={'md'}
                        borderWidth='1px'
                        placeholder={t('AddContentPage.descript')}
                        _placeholder={{
                          opacity: 1,
                          color: colorMode == 'light' ? 'gray.500' : 'white',
                        }}
                        value={updateContent?.carddescription}
                        onChange={(e) => {
                          setUpdateContentData({
                            carddescription: e.target.value,
                          });
                        }}
                      />
                    </InputGroup>
                    <FormControl p='2'>
                      <FormLabel>กลุ่มเนื้อหา</FormLabel>
                      <Select
                        value={getContentGroupId(updateContent) || ''}
                        onChange={(e) => setUpdateContentData({ contentGroup: e.target.value })}
                      >
                        <option value=''>ไม่อยู่ในกลุ่ม</option>
                        {contentGroups.map((group) => (
                          <option key={group._id} value={group._id}>
                            {group.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <Box p='2'>
                      <Alert status='info' borderRadius='md' mb={2}>
                        <AlertIcon />
                        ช่องรหัสนี้มีผลในการคำนวณ % ของรายวิชา เพราะใช้เชื่อม progress กับเนื้อหาในรายวิชาอื่น
                      </Alert>
                      <RadioGroup
                        value={updateContent?.progressLinkMode || (updateContent?.codeSlug ? 'linked' : 'none')}
                        onChange={(value) => {
                          setUpdateContentData({
                            progressLinkMode: value,
                            codeSlug: value === 'linked' ? updateContent?.codeSlug : '',
                          });
                        }}
                      >
                        <HStack spacing={4}>
                          <Radio value='none'>ไม่เชื่อมความคืบหน้า</Radio>
                          <Radio value='linked'>เชื่อมความคืบหน้ากับวิชาอื่น</Radio>
                        </HStack>
                      </RadioGroup>
                      {(updateContent?.progressLinkMode || (updateContent?.codeSlug ? 'linked' : 'none')) === 'linked' && (
                        <InputGroup mt={2}>
                          <Input
                            boxShadow={'md'}
                            borderWidth='1px'
                            placeholder={t('AddContentPage.codeSlug')}
                            _placeholder={{
                              opacity: 1,
                              color: colorMode == 'light' ? 'gray.500' : 'white',
                            }}
                            value={updateContent?.codeSlug}
                            onChange={(e) => {
                              setUpdateContentData({ codeSlug: e.target.value });
                            }}
                          />
                        </InputGroup>
                      )}
                    </Box>
                  </GridItem>
                </Grid>
                <Box p={'4'} borderRadius='lg' mt={'4'} borderWidth={'1px'}>
                  {updateContent?.type === 'text' && (
                    <FormControl id=''>
                      <InputGroup>
                        <InputLeftAddon boxShadow={'sm'} children={t('managecontentPage.type')} w={'15%'} />
                        <Input readOnly boxShadow={'sm'} bg={'gray.200'} value={t('managecontentPage.text')} />
                      </InputGroup>
                      <Box minHeight={'60vh'} border='1px solid'>
                        <Editor
                          editorState={editorState}
                          onEditorStateChange={setEditorState}
                          toolbar={{
                            options: [
                              'inline',
                              'blockType',
                              'fontSize',
                              'fontFamily',
                              'list',
                              'textAlign',
                              'colorPicker',
                              'link',
                              'emoji',
                              'remove',
                              'history',
                            ],
                          }}
                          // editorStyle={{ border: "1px solid" }}
                        />
                      </Box>
                      {statusDate === true ? (
                        <ThemeProvider theme={theme}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              // disableFuture
                              label={t('AddContentPage.date')}
                              // openTo="year"
                              // minDate={dayjs(Date.now())}
                              // views={['year', 'month', 'day']}
                              value={updateContent.expiredate ? updateContent.expiredate : ''}
                              onChange={(e) => setUpdateContentData({ expiredate: e })}
                              renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                            />
                          </LocalizationProvider>
                        </ThemeProvider>
                      ) : null}
                      <FormLabel>{t('managecontentPage.status')}</FormLabel>
                      <FormControl>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='green'
                          isChecked={updateContent?.statusActive}
                          onChange={(e) =>
                            setUpdateContentData({
                              statusActive: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.statusActive
                          ? t('managecontentPage.public')
                          : t('managecontentPage.nonepublic')}
                      </FormControl>
                      <FormControl mt={2}>
                        <FormLabel>{t('course.forFree')}</FormLabel>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='blue'
                          isChecked={updateContent?.public}
                          onChange={(e) =>
                            setUpdateContentData({
                              public: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.public ? 'เปิดดูฟรี' : 'ปิด'}
                      </FormControl>
                    </FormControl>
                  )}
                  {updateContent?.type === 'photo' && (
                    <FormControl id=''>
                      <FormLabel>{t('managecontentPage.photoNameOld')}</FormLabel>
                      <Box p={'4'} bg={'gray.300'} borderRadius='lg' align={'center'}>
                        <Image src={updateContent?.link} />
                      </Box>
                      <FormLabel>{t('managecontentPage.photoNameNew')}</FormLabel>
                      <Dropzone
                        onChange={updateFilesImg}
                        value={filesImg}
                        accept='image/*'
                        maxFiles='1'
                        view='grid'
                        //localization={"ES-es"}
                        //disableScroll
                      >
                        {filesImg.map((file, i) => (
                          <FileItem
                            {...file}
                            key={i}
                            onDelete={onDeleteImg}
                            //localization={"EN-en"}
                            //resultOnTooltip
                            preview={true}
                          />
                        ))}
                      </Dropzone>
                      <Checkbox
                        mt={3}
                        mb={3}
                        size='md'
                        isChecked={statusDate}
                        colorScheme='green'
                        onChange={(e) => setStatusDate(e.target.checked)}
                      >
                        {t('managecontentPage.expiredate')}
                      </Checkbox>
                      {statusDate === true ? (
                        <ThemeProvider theme={theme}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              // disableFuture
                              label={t('AddContentPage.date')}
                              // openTo="year"
                              // minDate={dayjs(Date.now())}
                              // views={['year', 'month', 'day']}
                              value={updateContent.expiredate ? updateContent.expiredate : ''}
                              onChange={(e) => setUpdateContentData({ expiredate: e })}
                              renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                            />
                          </LocalizationProvider>
                        </ThemeProvider>
                      ) : null}
                      <FormLabel>{t('managecontentPage.status')}</FormLabel>
                      <FormControl>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='green'
                          isChecked={updateContent?.statusActive}
                          onChange={(e) =>
                            setUpdateContentData({
                              statusActive: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.statusActive
                          ? t('managecontentPage.public')
                          : t('managecontentPage.nonepublic')}
                      </FormControl>
                      <FormControl mt={2}>
                        <FormLabel>{t('course.forFree')}</FormLabel>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='blue'
                          isChecked={updateContent?.public}
                          onChange={(e) =>
                            setUpdateContentData({
                              public: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.public ? 'เปิดดูฟรี' : 'ปิด'}
                      </FormControl>
                    </FormControl>
                  )}
                  {updateContent?.type === 'video' && (
                    <FormControl id=''>
                      <FormLabel>{t('managecontentPage.videoNameOld')}</FormLabel>
                      <Box p={'4'} borderRadius='lg' align={'center'}>
                        <Iframe src={updateContent?.link} width={'400px'} />
                      </Box>
                      <FormLabel>{t('managecontentPage.videoNameNew')}</FormLabel>
                      {renderVideoSourceControls(true)}
                      <Checkbox
                        mt={3}
                        mb={3}
                        size='md'
                        isChecked={statusDate}
                        colorScheme='green'
                        onChange={(e) => setStatusDate(e.target.checked)}
                      >
                        {t('managecontentPage.expiredate')}
                      </Checkbox>
                      {statusDate === true ? (
                        <ThemeProvider theme={theme}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              // disableFuture
                              label={t('AddContentPage.date')}
                              // openTo="year"
                              // minDate={dayjs(Date.now())}
                              // views={['year', 'month', 'day']}
                              value={updateContent.expiredate ? updateContent.expiredate : ''}
                              onChange={(e) => setUpdateContentData({ expiredate: e })}
                              renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                            />
                          </LocalizationProvider>
                        </ThemeProvider>
                      ) : null}
                      <FormLabel>{t('managecontentPage.status')}</FormLabel>
                      <FormControl py={'2'}>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='green'
                          isChecked={updateContent?.statusActive}
                          onChange={(e) =>
                            setUpdateContentData({
                              statusActive: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.statusActive
                          ? t('managecontentPage.public')
                          : t('managecontentPage.nonepublic')}
                      </FormControl>
                      <FormControl mt={2}>
                        <FormLabel>{t('course.forFree')}</FormLabel>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='blue'
                          isChecked={updateContent?.public}
                          onChange={(e) =>
                            setUpdateContentData({
                              public: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.public ? 'เปิดดูฟรี' : 'ปิด'}
                      </FormControl>
                    </FormControl>
                  )}

                  {updateContent?.type === 'document' && (
                    <Box>
                      <FormLabel>{t('managecontentPage.documentNameOld')}</FormLabel>
                      <Box p={'4'} borderRadius='lg' align={'center'}>
                        {updateContent?.link ? (
                          <VStack spacing={3} align='stretch'>
                            <Text fontSize='sm' wordBreak='break-all'>
                              {getDocumentNameFromUrl(updateContent.link)}
                            </Text>
                            <Link href={updateContent.link} isExternal>
                              <Button colorScheme='teal' variant='outline' leftIcon={<DownloadIcon />}>
                                เปิดไฟล์เดิม
                              </Button>
                            </Link>
                            {updateContent?.doctype === 'pdf' && (
                              <Iframe src={updateContent.link} width='100%' height='400px' />
                            )}
                          </VStack>
                        ) : (
                          <Alert status='warning'>
                            <AlertIcon />
                            ไม่พบไฟล์เอกสารเดิม
                          </Alert>
                        )}
                      </Box>
                      <FormLabel>{t('managecontentPage.documentNameNew')}</FormLabel>
                      <Dropzone
                        onChange={updateFilesDoc}
                        value={filesDoc}
                        maxFiles='1'
                        view='grid'
                        accept='.pdf,.doc,.docx,.xls,.xlsx'

                        //localization={"ES-es"}
                        //disableScroll
                      >
                        {filesDoc.map((file, i) => (
                          <FileItem
                            {...file}
                            key={i}
                            onDelete={onDeleteDoc}
                            //localization={"EN-en"}
                            //resultOnTooltip
                            preview={true}
                          />
                        ))}
                      </Dropzone>
                      {uploadState === 100 ? (
                        <Grid templateColumns='repeat(9, 1fr)' gap={1} py={'2'}>
                          <GridItem colSpan={8}>
                            <Progress value={uploadState} size='lg' borderRadius={'lg'} colorScheme='green' />
                          </GridItem>
                          <GridItem colSpan={1} align={'center'}>
                            <Text>{`${uploadState} %`}</Text>
                          </GridItem>
                        </Grid>
                      ) : (
                        <Grid templateColumns='repeat(9, 1fr)' gap={1} py={'2'}>
                          <GridItem colSpan={8}>
                            <Progress value={uploadState} hasStripe size='lg' borderRadius={'lg'} />
                          </GridItem>
                          <GridItem colSpan={1} align={'center'}>
                            <Text>{uploadState != 0 && `${uploadState} %`}</Text>
                          </GridItem>
                        </Grid>
                      )}
                      <Checkbox
                        mt={3}
                        mb={3}
                        size='md'
                        isChecked={statusDate}
                        colorScheme='green'
                        onChange={(e) => setStatusDate(e.target.checked)}
                      >
                        {t('managecontentPage.expiredate')}
                      </Checkbox>
                      {statusDate === true ? (
                        <ThemeProvider theme={theme}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              // disableFuture
                              label={t('AddContentPage.date')}
                              // openTo="year"
                              // minDate={dayjs(Date.now())}
                              // views={['year', 'month', 'day']}
                              value={updateContent.expiredate ? updateContent.expiredate : ''}
                              onChange={(e) => setUpdateContentData({ expiredate: e })}
                              renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                            />
                          </LocalizationProvider>
                        </ThemeProvider>
                      ) : null}
                      <FormLabel>{t('managecontentPage.status')}</FormLabel>
                      <FormControl>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='green'
                          isChecked={updateContent?.statusActive}
                          onChange={(e) =>
                            setUpdateContentData({
                              statusActive: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.statusActive
                          ? t('managecontentPage.public')
                          : t('managecontentPage.nonepublic')}
                      </FormControl>
                      <FormControl mt={2}>
                        <FormLabel>{t('course.forFree')}</FormLabel>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='blue'
                          isChecked={updateContent?.public}
                          onChange={(e) =>
                            setUpdateContentData({
                              public: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.public ? 'เปิดดูฟรี' : 'ปิด'}
                      </FormControl>
                    </Box>
                  )}

                  {updateContent?.type === 'link' && (
                    <Box>
                      <FormLabel>{t('managecontentPage.link')}</FormLabel>
                      <Input
                        value={updateContent?.link}
                        onChange={(e) => {
                          setUpdateContentData({ link: e.target.value });
                        }}
                        required
                      />
                      <Checkbox
                        mt={3}
                        mb={3}
                        size='md'
                        isChecked={statusDate}
                        colorScheme='green'
                        onChange={(e) => setStatusDate(e.target.checked)}
                      >
                        {t('managecontentPage.expiredate')}
                      </Checkbox>
                      {statusDate === true ? (
                        <ThemeProvider theme={theme}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              // disableFuture
                              label={t('AddContentPage.date')}
                              // openTo="year"
                              // minDate={dayjs(Date.now())}
                              // views={['year', 'month', 'day']}
                              value={updateContent.expiredate ? updateContent.expiredate : ''}
                              onChange={(e) => setUpdateContentData({ expiredate: e })}
                              renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                            />
                          </LocalizationProvider>
                        </ThemeProvider>
                      ) : null}
                      <FormLabel>{t('managecontentPage.status')}</FormLabel>
                      <FormControl>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='green'
                          isChecked={updateContent?.statusActive}
                          onChange={(e) =>
                            setUpdateContentData({
                              statusActive: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.statusActive
                          ? t('managecontentPage.public')
                          : t('managecontentPage.nonepublic')}
                      </FormControl>
                      <FormControl mt={2}>
                        <FormLabel>{t('course.forFree')}</FormLabel>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='blue'
                          isChecked={updateContent?.public}
                          onChange={(e) =>
                            setUpdateContentData({
                              public: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.public ? 'เปิดดูฟรี' : 'ปิด'}
                      </FormControl>
                    </Box>
                  )}

                  {updateContent?.type === 'homework' && (
                    <Box style={{ zIndex: 1 }}>
                      <Flex direction={['column', 'column', 'row', 'row']}>
                        <FormControl p={2}>
                          <FormLabel>{t('managecontentPage.description')}</FormLabel>
                          <Box minHeight={'51vh'} borderWidth='1px' borderRadius={'lg'} p={2}>
                            <Editor
                              editorState={editorHomeworkState}
                              onEditorStateChange={seteditorHomeworkState}
                              toolbar={{
                                options: [
                                  'inline',
                                  'blockType',
                                  'fontSize',
                                  'fontFamily',
                                  'list',
                                  'textAlign',
                                  'colorPicker',
                                  'link',
                                  'emoji',
                                  'remove',
                                  'history',
                                ],
                              }}
                              // editorStyle={{ border: "1px solid" }}
                            />
                          </Box>
                        </FormControl>
                        <FormControl p={2}>
                          <Box align={'center'}>
                            <FormLabel>{t('managecontentPage.documentNameOld')} :</FormLabel>
                            {updateContent?.homeworkconfig?.exampleFiletype == 'pdf' ? (
                              <Iframe
                                src={updateContent?.homeworkconfig?.exampleFile}
                                width={'400px'}
                                height={'400px'}
                              />
                            ) : (
                              <Link href={updateContent?.homeworkconfig?.exampleFile}>
                                {updateContent?.homeworkconfig?.exampleFile && (
                                  <Button colorScheme='teal' variant='solid' leftIcon={<DownloadIcon />}>
                                    Dowload
                                  </Button>
                                )}
                              </Link>
                            )}
                          </Box>
                          <FormLabel>{t('managecontentPage.documentNameNew')}</FormLabel>
                          <Dropzone
                            onChange={updateFilesDoc}
                            value={filesDoc}
                            maxFiles='1'
                            view='grid'
                            accept='.pdf,.doc,.docx,.xls,.xlsx'

                            //localization={"ES-es"}
                            //disableScroll
                          >
                            {filesDoc.map((file, i) => (
                              <FileItem
                                {...file}
                                key={i}
                                onDelete={onDeleteDoc}
                                //localization={"EN-en"}
                                //resultOnTooltip
                                preview={true}
                              />
                            ))}
                          </Dropzone>
                        </FormControl>
                      </Flex>

                      <Flex direction={['column', 'row', 'row', 'row']}>
                        <FormControl p={2}>
                          <FormLabel>{t('managecontentPage.duedate')}</FormLabel>
                          <Box style={{ zIndex: 3 }} mt={'2'}>
                            <ThemeProvider theme={theme}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div style={{ zIndex: 9999 }}>
                                  <DateTimePicker
                                    // disableFuture
                                    label={t('managecontentPage.date')}
                                    // sx={{"#css-1ozefeb":{zIndex:"20000 !important"}}}
                                    // openTo="year"
                                    minDate={dayjs(Date.now())}
                                    // views={['year', 'month', 'day']}
                                    value={
                                      updateContent?.homeworkconfig?.duedate
                                        ? updateContent?.homeworkconfig?.duedate
                                        : ''
                                    }
                                    onChange={(e) => setUpdateContentData({ duedate: e })}
                                    renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                                  />
                                </div>
                              </LocalizationProvider>
                            </ThemeProvider>
                          </Box>
                        </FormControl>
                        <FormControl p={2}>
                          <FormLabel>{t('AddContentPage.typefile')}</FormLabel>
                          {console.log('LOGMAN', updateContent)}
                          <Select value={typeDocHomework} onChange={(e) => setTypeDocHomework(e.target.value)}>
                            <option value='pdf'>{t('AddContentPage.pdf_type')}</option>
                            <option value='xls'>{t('AddContentPage.xls_type')}</option>
                            <option value='doc'>{t('AddContentPage.doc_type')}</option>
                            <option value='image/*'>{t('AddContentPage.photo_type')}</option>
                            <option value='video'>{t('AddContentPage.video_type')}</option>
                            <option value='docx'>{t('AddContentPage.docx_type')}</option>
                          </Select>
                        </FormControl>
                      </Flex>
                      <FormControl p={2}>
                        <Checkbox size='md' isChecked={statusDate} onChange={(e) => setStatusDate(e.target.checked)}>
                          {t('managecontentPage.expiredate')}
                        </Checkbox>
                        {statusDate === true ? (
                          <Box mt={'2'}>
                            <ThemeProvider theme={theme}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                  // disableFuture
                                  label={t('AddContentPage.date')}
                                  // openTo="year"
                                  // minDate={dayjs(Date.now())}
                                  // views={['year', 'month', 'day']}
                                  value={updateContent.expiredate ? updateContent.expiredate : ''}
                                  onChange={(e) => setUpdateContentData({ expiredate: e })}
                                  renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                                />
                              </LocalizationProvider>
                            </ThemeProvider>
                          </Box>
                        ) : null}
                      </FormControl>
                      <FormLabel>{t('managecontentPage.status')}</FormLabel>
                      <FormControl>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='green'
                          isChecked={updateContent?.statusActive}
                          onChange={(e) =>
                            setUpdateContentData({
                              statusActive: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.statusActive
                          ? t('managecontentPage.public')
                          : t('managecontentPage.nonepublic')}
                      </FormControl>
                      <FormControl mt={2}>
                        <FormLabel>{t('course.forFree')}</FormLabel>
                        <Switch
                          size='lg'
                          mr={'2'}
                          colorScheme='blue'
                          isChecked={updateContent?.public}
                          onChange={(e) =>
                            setUpdateContentData({
                              public: e.target.checked,
                            })
                          }
                        />
                        {updateContent?.public ? 'เปิดดูฟรี' : 'ปิด'}
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </Box>
            </ModalBody>
            <ModalFooter>
              <Center>
                <Button
                  type='submit'
                  bg={'primary.700'}
                  color={'white'}
                  _hover={{
                    transform: 'translateY(-2px)',
                    boxShadow: 'lg',
                  }}
                >
                  {t('managecontentPage.confirmButton')}
                </Button>
              </Center>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      {/* <Modal isOpen={isContentSorting} onClose={onSortingClose} size={'5xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t('managecontentPage.sortcontent')}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {contentState?.length != 0 &&
                            <Box borderWidth='2px' borderRadius='lg' overflow='hidden' p={2} >
                                <OrderGroup className={'group'} mode={'between'} >
                                    {sortingState?.map((content, i) => (
                                        list?.map((data) => {
                                            if (data?._id == content) {
                                                return (
                                                    <>
                                                        <OrderItem key={i}
                                                            index={i}
                                                            onMove={(to) => {
                                                                setRefetchList(true)
                                                                setSortingState(arrayMove(sortingState, i, to))
                                                            }}
                                                            wrapperClassName={'wrapper'}
                                                            wrapperStyle={{
                                                                width: 'revert', left: '0px', '@media screen and (maxWidth: 600px)': {
                                                                    left: '40px'
                                                                }
                                                            }}
                                                            inactiveStyle={{ background: colorMode === 'light' ? 'gray.500' : '#2f3748' }}
                                                            wrapperHoverClassName={'hover'}
                                                            className={'item'}
                                                            grabbingClassName={'grabbing'}
                                                            style={{
                                                                width: 'auto', height: "80px", borderWidth: '1px', overflowX: 'auto'
                                                            }}
                                                        >
                                                            <OrderItem.Handle className={'handle'}>
                                                                <VStack>
                                                                    <HamburgerIcon color={colorMode === 'light' ? 'black' : 'white'} />
                                                                </VStack>
                                                            </OrderItem.Handle>

                                                            <HStack p={2} justifyContent={'space-between'} spacing='10px' w='full' direction={'row'} overflowX={'auto'}>
                                                                <InputGroup colorScheme={'twitter'} size={['xs', 'sm', 'lg']} boxShadow={'md'} borderRadius={'md'} borderWidth={'1px'} maxWidth={'800px'}>
                                                                    <InputLeftAddon sx={{ fontSize: ['xs', 'sm', 'md'] }} borderRadius={'md'} children={t('managecontentPage.name')} height="3vh" p={5} />
                                                                    <Text p={'2'}
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            maxWidth: '400px'
                                                                        }}>{data?.name}</Text>
                                                                </InputGroup>
                                                                <InputGroup colorScheme={'twitter'} size={['xs', 'sm', 'lg']} boxShadow={'md'} borderRadius={'md'} borderWidth={'1px'} maxWidth={'200px'}>
                                                                    <InputLeftAddon sx={{ fontSize: ['xs', 'sm', 'md'] }} borderRadius={'md'} children={t('managecontentPage.type')} height="3vh" p={5} />
                                                                    <Text p={'2'}>{data?.type}</Text>
                                                                </InputGroup>
                                                            </HStack>
                                                        </OrderItem>
                                                    </>)
                                            }
                                        })
                                    ))}
                                </OrderGroup>
                            </Box>
                        }
                        {contentState?.length == 0 &&
                            <Box align="center" borderRadius={'lg'} w={'full'} py={'20'} color={'gray.500'} bg={'gray.200'}><Heading>{t('managecontentPage.warningcontentempty')}</Heading></Box>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onSortingClose}>
                            {t('Button.close')}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal> */}

      <Modal isOpen={isPreviewOpen} onClose={onPreviewClose} style={{ zIndex: 1 }} size={'2xl'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader> {t('managecontentPage.content')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {updateContent?.type === 'text' && (
              <FormControl id=''>
                <FormLabel fontSize={20}>{t('managecontentPage.chapterName')}</FormLabel>
                <Box p={'4'} bg={'gray.300'} borderRadius='lg'>
                  {updateContent?.name}
                </Box>
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.text')}
                </FormLabel>
                <Box p={'4'} bg={'gray.300'} borderRadius='lg'>
                  {updateContent?.texteditor ? handleConvertHTML(updateContent?.texteditor) : '-'}
                </Box>
                {updateContent?.expiredate !== null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(updateContent?.expiredat).format('DD/MM/YYYY , HH:mm:ss')}
                  </Box>
                )}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.status')}
                </FormLabel>

                <FormControl py={'2'}>
                  <Switch
                    isReadOnly
                    size='lg'
                    mr={'2'}
                    colorScheme='green'
                    isChecked={updateContent?.statusActive}
                    onChange={(e) => setUpdateContentData({ statusActive: e.target.checked })}
                  />
                  {updateContent?.statusActive ? t('managecontentPage.public') : t('managecontentPage.nonepublic')}
                </FormControl>
              </FormControl>
            )}
            {updateContent?.type === 'photo' && (
              <FormControl id=''>
                <FormLabel fontSize={20}>{t('managecontentPage.photoName')}</FormLabel>- {updateContent?.name}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.photo')}
                </FormLabel>
                <Box p={'4'} bg={'gray.300'} borderRadius='lg' align={'center'}>
                  <Image src={updateContent?.link} />
                </Box>
                {updateContent?.expiredate !== null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(updateContent?.expiredat).format('DD/MM/YYYY ,  HH:mm:ss')}
                  </Box>
                )}
                <FormControl py={'2'}>
                  <Switch isReadOnly size='lg' mr={'2'} colorScheme='green' isChecked={updateContent?.statusActive} />
                  {updateContent?.statusActive ? t('managecontentPage.public') : t('managecontentPage.nonepublic')}
                </FormControl>
              </FormControl>
            )}
            {updateContent?.type === 'video' && (
              <FormControl id=''>
                <FormLabel fontSize={20}>{t('managecontentPage.videoName')}</FormLabel>- {updateContent?.name}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.video')}
                </FormLabel>
                <Box p={'4'} bg={'gray.300'} borderRadius='lg' align={'center'}>
                  <Iframe src={updateContent?.link} width={'400px'} height={'400px'} />
                </Box>
                {updateContent?.expiredate !== null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(updateContent?.expiredat).format('DD/MM/YYYY ,  HH:mm:ss')}
                  </Box>
                )}
                <FormControl py={'2'}>
                  <Switch isReadOnly size='lg' colorScheme='green' isChecked={updateContent?.statusActive}>
                    {updateContent?.statusActive ? t('managecontentPage.public') : t('managecontentPage.nonepublic')}
                  </Switch>
                </FormControl>
              </FormControl>
            )}
            {updateContent?.type === 'document' && (
              <Box>
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.document')}
                </FormLabel>
                <Box p={'4'} bg={'gray.300'} borderRadius='lg' align={'center'}>
                  {updateContent?.doctype == 'pdf' ? (
                    <Iframe src={updateContent?.link} width={'400px'} height={'400px'} />
                  ) : (
                    <Link href={updateContent?.link}>
                      <Button colorScheme='teal' variant='solid' leftIcon={<DownloadIcon />}>
                        Dowload
                      </Button>
                    </Link>
                  )}
                </Box>
                {updateContent?.expiredate !== null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(updateContent?.expiredate).format('DD/MM/YYYY ,  HH:mm:ss')}
                  </Box>
                )}
                <FormControl py={'2'}>
                  <Switch size='lg' mr={'2'} isReadOnly colorScheme='green' isChecked={updateContent?.statusActive} />
                  {updateContent?.statusActive ? t('managecontentPage.public') : t('managecontentPage.nonepublic')}
                </FormControl>
              </Box>
            )}
            {updateContent?.type === 'link' && (
              <>
                <FormLabel fontSize={20}>{t('managecontentPage.content')}</FormLabel>
                <Box p='2' borderRadius={'lg'} boxShadow={'lg'} borderWidth={'1px'}>
                  {updateContent?.name}
                </Box>
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.link')}
                </FormLabel>
                <Box p='2' borderRadius={'lg'} boxShadow={'lg'} borderWidth={'1px'}>
                  <Link isExternal href={`${updateContent?.link}`}>
                    {updateContent?.link}
                  </Link>
                </Box>

                {updateContent?.expiredate != null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(updateContent?.expiredat).format('DD/MM/YYYY ,  HH:mm:ss')}
                  </Box>
                )}
                <FormControl py={'2'}>
                  <FormLabel fontSize={20}>{t('managecontentPage.status')}</FormLabel>
                  <Switch
                    size='lg'
                    mr={'2'}
                    colorScheme='green'
                    isReadOnly
                    isChecked={updateContent?.statusActive}
                    onChange={(e) => setUpdateContentData({ statusActive: e.target.checked })}
                  />
                  {updateContent?.statusActive ? t('managecontentPage.public') : t('managecontentPage.nonepublic')}
                </FormControl>
              </>
            )}
            {updateContent?.type === 'homework' && (
              <Box style={{ zIndex: 2000 }}>
                <FormLabel fontSize={20}>{t('managecontentPage.homeworkName')}</FormLabel>- {updateContent?.name}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.description')}
                </FormLabel>
                {handleConvertHTML(updateContent?.homeworkconfig?.description)}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.duedate')}
                </FormLabel>
                -{dayjs(updateContent?.homeworkconfig?.duedate).format('DD/MM/YYYY ,  HH:mm:ss')}
                {updateContent?.expiredate != null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(updateContent?.expiredat).format('DD/MM/YYYY ,  HH:mm:ss')}
                  </Box>
                )}
                {updateContent?.homeworkconfig?.exampleFile != null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.exampleFile')}
                    </FormLabel>
                    <Iframe src={updateContent?.homeworkconfig?.exampleFile} width={'400px'} height={'400px'} />
                  </Box>
                )}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.status')}
                </FormLabel>
                <FormControl>
                  <Switch
                    size='lg'
                    mr={'2'}
                    colorScheme='green'
                    isReadOnly
                    isChecked={updateContent?.statusActive}
                    onChange={(e) => setUpdateContentData({ statusActive: e.target.checked })}
                  />
                  {updateContent?.statusActive ? t('managecontentPage.public') : t('managecontentPage.nonepublic')}
                </FormControl>
              </Box>
            )}
            {updateContent?.type === 'quiz' && (
              <Box style={{ zIndex: 2000 }}>
                <FormLabel fontSize={20}>{t('managecontentPage.QuestionName')}</FormLabel>- {preview?.name}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.description')}
                </FormLabel>
                - {preview?.questionconfig?.description}
                {updateContent?.questionconfig?.startdate != null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.startdate')}
                    </FormLabel>
                    - {dayjs(preview?.questionconfig?.startdate).format('DD/MM/YYYY , HH:mm:ss')}
                  </Box>
                )}
                {updateContent?.questionconfig?.duedate != null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.duedate')}
                    </FormLabel>
                    - {dayjs(preview?.questionconfig?.duedate).format('DD/MM/YYYY , HH:mm:ss')}
                  </Box>
                )}
                {updateContent?.expiredate != null && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(preview?.questionconfig?.duedate).format('DD/MM/YYYY , HH:mm:ss')}
                  </Box>
                )}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.status')}
                </FormLabel>
                <FormControl>
                  <Switch
                    size='lg'
                    mr={'2'}
                    colorScheme='green'
                    isReadOnly
                    isChecked={updateContent?.statusActive}
                    onChange={(e) => setUpdateContentData({ statusActive: e.target.checked })}
                  />
                  {updateContent?.statusActive ? t('managecontentPage.public') : t('managecontentPage.nonepublic')}
                </FormControl>
                {/* {dayjs(updateContent?.questionconfig?.duedate).format('DD MM YYYY , เวลา HH:mm:ss')} */}
                {updateContent?.questionconfig?.questionList?.length != 0 && (
                  <Box>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.example')}
                    </FormLabel>
                    <Stack spacing={3}>
                      <Box
                        sx={{
                          overflowX: ['auto', 'auto', 'none'],
                          maxW: ['350px', 'none'],
                        }}
                      >
                        <Table variant='simple'>
                          <Thead height='50px'>
                            <Tr>
                              <Th bg={bg}>{t('managecontentPage.question')}</Th>
                              <Th bg={bg}>{t('managecontentPage.choice')}</Th>
                              <Th bg={bg}>{t('managecontentPage.answer')}</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {preview?.questionconfig?.questionList?.map((questions, i) => (
                              <Tr key={i}>
                                <Td>{questions?.question}</Td>
                                {/* <Td>{questions?.choices.map((choice, i) => (<Text key={i}>{i + 1}{choice}</Text>))}</Td>
                                                                <Td>{questions?.answer}</Td> */}
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </Box>
                    </Stack>
                  </Box>
                )}
              </Box>
            )}
            {updateContent?.type === 'survey' && (
              <Box style={{ zIndex: 2000 }}>
                <FormLabel fontSize={20}>{t('managecontentPage.QuestionName')}</FormLabel>- {preview?.name}
                <FormLabel mt={2} fontSize={20}>
                  {t('managecontentPage.description')}
                </FormLabel>
                - {preview?.questionconfig?.description}
                {updateContent?.surveyconfig?.startdate != null && (
                  <>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.startdate')}
                    </FormLabel>
                    - {dayjs(preview?.surveyconfig?.startdate).format('DD/MM/YYYY , HH:mm:ss')}
                  </>
                )}
                {updateContent?.surveyconfig?.duedate != null && (
                  <>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.duedate')}
                    </FormLabel>
                    - {dayjs(preview?.surveyconfig?.duedate).format('DD/MM/YYYY , HH:mm:ss')}
                  </>
                )}
                {updateContent?.expiredate != null && (
                  <>
                    <FormLabel mt={2} fontSize={20}>
                      {t('managecontentPage.expiredate')}
                    </FormLabel>
                    - {dayjs(preview?.surveyconfig?.duedate).format('DD/MM/YYYY , HH:mm:ss')}
                  </>
                )}
                <Box>
                  <FormLabel mt={2} fontSize={20}>
                    {t('managecontentPage.example')}
                  </FormLabel>
                  <Survey.Survey
                    json={
                      preview
                        ? {
                            questions: preview?.surveyconfig?.surveyQuestions?.questions,
                          }
                        : { questions: {} }
                    }
                    // data={previewSurvey?.surveyAnswers}
                    showCompletedPage={false}
                    mode='display'
                  />
                </Box>
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* //ADDCONTENT */}
      <Modal isOpen={isAddContentOpen} onClose={modalAddContentClose} size={'5xl'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('managecontentPage.addcontent')}</ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleAddContent}>
            <ModalBody>
              <Box maxW='7xl' mx={'auto'} px={{ base: 2, sm: 12, md: 17 }}>
                <Grid
                  boxShadow={'xl'}
                  templateRows='repeat(1, 1fr)'
                  templateColumns='repeat(5, 1fr)'
                  borderWidth={'1px'}
                  borderRadius='lg'
                >
                  <GridItem rowSpan={1} colSpan={1} bg={'primary.900'} borderLeftRadius='lg'>
                    <Center pt={5}>
                      <Stack>
                        <Flex
                          boxShadow={'dark-lg'}
                          borderWidth='5px'
                          borderColor={'primary.800'}
                          w={[10, 10, 14, 20]}
                          h={[10, 10, 14, 20]}
                          align={'center'}
                          justify={'center'}
                          color={'primary.900'}
                          rounded={'full'}
                          bg={'white'}
                          mb={1}
                        >
                          <Text fontSize={'18px'} as='samp'>
                            {'1'}
                          </Text>
                        </Flex>
                      </Stack>
                    </Center>
                  </GridItem>
                  <GridItem colSpan={4}>
                    <InputGroup p={'2'}>
                      <Input
                        boxShadow={'md'}
                        borderWidth='1px'
                        placeholder={t('AddContentPage.contentname')}
                        _placeholder={{
                          opacity: 1,
                          color: colorMode == 'light' ? 'gray.500' : 'white',
                        }}
                        value={contentData?.name}
                        onChange={(e) => {
                          setContentData({ name: e.target.value });
                        }}
                      />
                    </InputGroup>
                    <InputGroup p={'2'}>
                      <Input
                        boxShadow={'md'}
                        borderWidth='1px'
                        placeholder={t('AddContentPage.descript')}
                        _placeholder={{
                          opacity: 1,
                          color: colorMode == 'light' ? 'gray.500' : 'white',
                        }}
                        value={contentData?.carddescription}
                        onChange={(e) => {
                          setContentData({ carddescription: e.target.value });
                        }}
                      />
                    </InputGroup>
                    <FormControl p='2'>
                      <FormLabel>กลุ่มเนื้อหา</FormLabel>
                      <Select value={getContentGroupId(contentData) || ''} onChange={(e) => setContentData({ contentGroup: e.target.value })}>
                        <option value=''>ไม่อยู่ในกลุ่ม</option>
                        {contentGroups.map((group) => (
                          <option key={group._id} value={group._id}>
                            {group.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <Box p='2'>
                      <Alert status='info' borderRadius='md' mb={2}>
                        <AlertIcon />
                        ช่องรหัสนี้มีผลในการคำนวณ % ของรายวิชา เพราะใช้เชื่อม progress กับเนื้อหาในรายวิชาอื่น
                      </Alert>
                      <RadioGroup
                        value={contentData?.progressLinkMode || 'none'}
                        onChange={(value) => setContentData({ progressLinkMode: value, codeSlug: value === 'linked' ? contentData?.codeSlug : '' })}
                      >
                        <HStack spacing={4}>
                          <Radio value='none'>ไม่เชื่อมความคืบหน้า</Radio>
                          <Radio value='linked'>เชื่อมความคืบหน้ากับวิชาอื่น</Radio>
                        </HStack>
                      </RadioGroup>
                      {contentData?.progressLinkMode === 'linked' && (
                        <InputGroup mt={2}>
                          <Input
                            boxShadow={'md'}
                            borderWidth='1px'
                            placeholder={t('AddContentPage.codeSlug')}
                            _placeholder={{
                              opacity: 1,
                              color: colorMode == 'light' ? 'gray.500' : 'white',
                            }}
                            value={contentData?.codeSlug}
                            onChange={(e) => {
                              setContentData({ codeSlug: e.target.value });
                            }}
                          />
                        </InputGroup>
                      )}
                    </Box>
                  </GridItem>
                </Grid>
                <FormControl py={'4'}>
                  <InputGroup>
                    <InputLeftAddon boxShadow={'sm'} children={t('AddContentPage.type')} />
                    <Select
                      defaultValue='empty'
                      onChange={(e) => {
                        setContentData({ type: e.target.value });
                      }}
                    >
                      <option value='empty'> {t('AddContentPage.choosetype')}</option>
                      {/* <option value='text'>{t('AddContentPage.text')}</option> */}
                      {/* <option value='photo'>{t('AddContentPage.photo')}</option> */}
                      <option value='video'> {t('AddContentPage.video')}</option>
                      <option value='homework'>{t('AddContentPage.homework')}</option>
                      <option value='document'>{t('AddContentPage.document')}</option>
                      <option value='link'>{t('AddContentPage.link')}</option>
                      <option value='quiz'>{t('AddContentPage.quiz')}</option>
                      <option value='survey'>{t('AddContentPage.survey')}</option>
                    </Select>
                  </InputGroup>
                </FormControl>
                {contentData?.type !== 'empty' && (
                  <Box p={'4'} borderRadius='lg' mt={'4'} borderWidth={'1px'}>
                    {contentData?.type === 'text' && (
                      <Box>
                        <FormControl>
                          <Box minHeight={'60vh'} border='1px solid'>
                            <Editor
                              editorState={editorState}
                              onEditorStateChange={setEditorState}
                              toolbar={{
                                options: [
                                  'inline',
                                  'blockType',
                                  'fontSize',
                                  'fontFamily',
                                  'list',
                                  'textAlign',
                                  'colorPicker',
                                  'link',
                                  'emoji',
                                  'remove',
                                  'history',
                                ],
                              }}
                              // editorStyle={{ border: "1px solid", }}
                            />
                          </Box>
                        </FormControl>
                        <FormControl>
                          <FormLabel>{t('managecontentPage.status')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}

                    {contentData?.type === 'photo' && (
                      <Box>
                        <FormControl>
                          <Dropzone
                            onChange={updateFilesImg}
                            value={filesImg}
                            accept='image/*'
                            maxFiles='1'
                            view='grid'
                          >
                            {filesImg.map((file) => (
                              <FileItem
                                {...file}
                                key={file.id}
                                onDelete={onDeleteImg}
                                //localization={"EN-en"}
                                //resultOnTooltip
                                preview={true}
                              />
                            ))}
                          </Dropzone>
                        </FormControl>
                        <FormControl>
                          {/* <FormLabel>{t('managecontentPage.status')}</FormLabel> */}
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}

                    {contentData?.type === 'video' && (
                      <Box>
                        <FormControl>
                          {renderVideoSourceControls(false)}
                        </FormControl>
                        <FormControl>
                          {/* <FormLabel>{t('managecontentPage.status')}</FormLabel> */}
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}

                    {contentData?.type === 'homework' && (
                      <Box>
                        <Flex direction={['column', 'row', 'row', 'row']}>
                          <FormControl p={2}>
                            <FormLabel>{t('AddContentPage.description')}</FormLabel>
                            <Box minHeight={'46vh'} borderWidth='1px' p={'1'} borderRadius={'lg'}>
                              <Editor
                                editorState={editorHomeworkState}
                                onEditorStateChange={seteditorHomeworkState}
                                toolbar={{
                                  options: [
                                    'inline',
                                    'blockType',
                                    'fontSize',
                                    'fontFamily',
                                    'list',
                                    'textAlign',
                                    'colorPicker',
                                    'link',
                                    'emoji',
                                    'remove',
                                    'history',
                                  ],
                                }}
                                // editorStyle={{ border: "1px solid" }}
                              />
                            </Box>
                          </FormControl>
                          <FormControl p={2}>
                            <FormLabel>{t('AddContentPage.exampleFile')}</FormLabel>
                            <Dropzone
                              onChange={updateFilesDoc}
                              value={filesDoc}
                              maxFiles='1'
                              view='grid'
                              // localization={"ES-es"}
                              // disableScroll
                              accept='.pdf,.doc,.docx,.xls,.xlsx'
                            >
                              {filesDoc.map((file) => (
                                <FileItem
                                  {...file}
                                  key={file.id}
                                  onDelete={onDeleteDoc}
                                  localization={'EN-en'}
                                  resultOnTooltip
                                  preview={true}
                                />
                              ))}
                            </Dropzone>
                          </FormControl>
                        </Flex>
                        <Flex direction={['column', 'row', 'row', 'row']}>
                          <FormControl p={2}>
                            <FormLabel>{t('AddContentPage.duedate')}</FormLabel>
                            <ThemeProvider theme={theme}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                  // disableFuture
                                  label={t('AddContentPage.date')}
                                  // openTo="year"
                                  minDate={dayjs(Date.now())}
                                  // views={['year', 'month', 'day']}
                                  value={contentData?.date ? contentData?.date : ''}
                                  onChange={(e) => setContentData({ date: e })}
                                  renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                                />
                              </LocalizationProvider>
                            </ThemeProvider>
                          </FormControl>
                          <FormControl p={2}>
                            <FormLabel>{t('AddContentPage.typefile')}</FormLabel>
                            <Select defaultValue='pdf' onChange={(e) => setContentData({ typefile: e.target.value })}>
                              <option value=''>{'กรุณาเลือกไฟล์ที่ต้องการให้ส่ง'}</option>
                              <option value='pdf'>{t('AddContentPage.pdf_type')}</option>
                              <option value='xls'>{t('AddContentPage.xls_type')}</option>
                              <option value='doc'>{t('AddContentPage.doc_type')}</option>
                              <option value='docx'>{t('AddContentPage.docx_type')}</option>
                              <option value='image/*'>{t('AddContentPage.photo_type')}</option>
                              <option value='video'>{t('AddContentPage.video_type')}</option>
                            </Select>
                          </FormControl>
                        </Flex>
                        <FormControl p={2}>
                          <Checkbox size='md' isChecked={statusDate} onChange={(e) => setStatusDate(e.target.checked)}>
                            {t('managecontentPage.expiredate')}
                          </Checkbox>
                          {statusDate === true ? (
                            <Box mt={'2'}>
                              <ThemeProvider theme={theme}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DateTimePicker
                                    // disableFuture
                                    label={t('AddContentPage.date')}
                                    // openTo="year"
                                    // minDate={dayjs(Date.now())}
                                    // views={['year', 'month', 'day']}
                                    value={contentData.expiredate ? contentData?.expiredate : ''}
                                    onChange={(e) => setContentData({ expiredate: e })}
                                    renderInput={(params) => <TextField fullWidth required size='small' {...params} />}
                                  />
                                </LocalizationProvider>
                              </ThemeProvider>
                            </Box>
                          ) : null}
                        </FormControl>
                        <FormControl>
                          <FormLabel>{t('managecontentPage.status')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}

                    {contentData?.type === 'document' && (
                      <Box>
                        <FormControl>
                          <Dropzone
                            onChange={updateFilesDoc}
                            value={filesDoc}
                            maxFiles='1'
                            view='grid'
                            accept='.pdf,.doc,.docx,.xls,.xlsx'
                            //localization={"ES-es"}
                            //disableScroll
                          >
                            {/* {console.log("file", filesDoc)} */}
                            {filesDoc.map((file) => (
                              <FileItem
                                {...file}
                                key={file.id}
                                onDelete={onDeleteDoc}
                                //localization={"EN-en"}
                                //resultOnTooltip
                                preview={true}
                              />
                            ))}
                          </Dropzone>
                          {uploadState === 100 ? (
                            <Grid templateColumns='repeat(9, 1fr)' gap={1} py={'2'}>
                              <GridItem colSpan={8}>
                                <Progress value={uploadState} size='lg' borderRadius={'lg'} colorScheme='green' />
                              </GridItem>
                              <GridItem colSpan={1} align={'center'}>
                                <Text>{`${uploadState} %`}</Text>
                              </GridItem>
                            </Grid>
                          ) : (
                            <Grid templateColumns='repeat(9, 1fr)' gap={1} py={'2'}>
                              <GridItem colSpan={8}>
                                <Progress value={uploadState} hasStripe size='lg' borderRadius={'lg'} />
                              </GridItem>
                              <GridItem colSpan={1} align={'center'}>
                                <Text>{uploadState != 0 && `${uploadState} %`}</Text>
                              </GridItem>
                            </Grid>
                          )}
                        </FormControl>
                        <FormControl>
                          <FormLabel>{t('managecontentPage.status')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}

                    {contentData?.type === 'link' && (
                      <Box>
                        <FormControl>
                          <Input
                            required
                            onChange={(e) => {
                              setContentData({ link: e.target.value });
                            }}
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>{t('managecontentPage.status')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}

                    {contentData?.type === 'quiz' && (
                      <Box>
                        <FormControl id=''>
                          <Textarea
                            resize='vertical'
                            size='lg'
                            height='100px'
                            mt={2}
                            placeholder={t('managecontentPage.placeholderDescription')}
                            onChange={(e) => {
                              setContentData({ description: e.target.value });
                            }}
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>{t('managecontentPage.status')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isDisabled
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}

                    {contentData?.type === 'survey' && (
                      <Box>
                        <FormLabel>{t('AddContentPage.description')}</FormLabel>
                        <Box minHeight={'60vh'} borderWidth='1px' borderRadius={'lg'} p={1}>
                          <Editor
                            editorState={editorHomeworkState}
                            onEditorStateChange={seteditorHomeworkState}
                            toolbar={{
                              options: [
                                'inline',
                                'blockType',
                                'fontSize',
                                'fontFamily',
                                'list',
                                'textAlign',
                                'colorPicker',
                                'link',
                                'emoji',
                                'remove',
                                'history',
                              ],
                            }}
                            // editorStyle={{ border: "1px solid" }}
                          />
                        </Box>
                        <FormControl>
                          <FormLabel>{t('managecontentPage.status')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='green'
                            isDisabled
                            isChecked={contentData?.statusActive}
                            onChange={(e) => setContentData({ statusActive: e.target.checked })}
                          />
                          {contentData?.statusActive
                            ? t('managecontentPage.public')
                            : t('managecontentPage.nonepublic')}
                        </FormControl>
                        <FormControl mt={2}>
                          <FormLabel>{t('course.forFree')}</FormLabel>
                          <Switch
                            size='lg'
                            mr={'2'}
                            colorScheme='blue'
                            isChecked={contentData?.public}
                            onChange={(e) => setContentData({ public: e.target.checked })}
                          />
                          {contentData?.public ? 'เปิดดูฟรี' : 'ปิด'}
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </ModalBody>
            <ModalFooter>
              <Center>
                <Button
                  type='submit '
                  bg={'primary.700'}
                  color={'white'}
                  _hover={{
                    transform: 'translateY(-2px)',
                    boxShadow: 'lg',
                  }}
                >
                  {t('managecontentPage.confirmButton')}
                </Button>
              </Center>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      <AlertDialog isOpen={showRemoveContent} onClose={handleCloseRemoveContent}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <form onSubmit={handleRemoveContent}>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                {t('managecontentPage.deleteChapter')}
              </AlertDialogHeader>
              <AlertDialogBody>
                {t('managecontentPage.youDelete')} {removeContentIndex?.name}
              </AlertDialogBody>
              <AlertDialogFooter>
                <Button onClick={handleCloseRemoveContent}>{t('managecontentPage.closeButton')}</Button>
                <Button
                  bg={'primary.700'}
                  color={'white'}
                  _hover={{
                    transform: 'translateY(-2px)',
                    boxShadow: 'lg',
                  }}
                  type='submit'
                  ml={3}
                >
                  {t('managecontentPage.removeButton')}
                </Button>
              </AlertDialogFooter>
            </form>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <Box w='100%' px={[2, 10, 20, 20]} style={{ zIndex: 2000 }} minHeight={'90vh'}>
        <Container maxW={'7xl'} py={16} spacing={12}>
          <Stack spacing={0} align={'center'}>
            <Heading variant='h4'>{t('managecontentPage.title')}</Heading>
            <Text>{t('managecontentPage.subtitle')}</Text>
          </Stack>
          {SubjectData?.subject?.name && (
            <Heading as='h2' size='xl' mt={10} textAlign='center'>
              {SubjectData.subject.name}
            </Heading>
          )}
          <Stack spacing='8px' direction={['column', 'column', 'row']} justify={'end'} mt={8}>
            <Button
              w={['100%', '30%', '30%', '16%']}
              mr={2}
              leftIcon={<AddIcon />}
              variant='outline'
              colorScheme='teal'
              onClick={openCreateContentGroupModal}
            >
              เพิ่มกลุ่มเนื้อหา
            </Button>
            <Button
              w={['100%', '30%', '30%', '12%']}
              mr={2}
              leftIcon={<AddIcon />}
              bg={'primary.700'}
              color={'white'}
              _hover={{ transform: 'translateY(-2px)', boxShadow: 'lg' }}
              onClick={() => {
                modalAddContentOpen();
              }}
            >
              {t('managecontentPage.addcontent')}
            </Button>
            <Button
              leftIcon={<FaSortAmountDown />}
              mr={2}
              bg={'primary.700'}
              color={'white'}
              _hover={{
                transform: 'translateY(-2px)',
                boxShadow: 'lg',
              }}
              onClick={() => {
                onSortingOpen();
              }}
            >
              {t('managecontentPage.sortcontent')}
            </Button>
            <IconButton
              icon={<RepeatIcon />}
              bg={'primary.700'}
              color={'white'}
              _hover={{
                transform: 'translateY(-2px)',
                boxShadow: 'lg',
              }}
              onClick={(e) => {
                e.preventDefault();
                handleRefetchContent();
              }}
            />
          </Stack>

          <Box mt={6} p={4} borderWidth='1px' borderRadius='lg' bg={colorMode === 'light' ? 'white' : 'gray.700'}>
            <Flex justify='space-between' align='center' mb={3}>
              <Heading size='md'>กลุ่มของเนื้อหา</Heading>
              <Badge colorScheme='teal'>{contentGroups.length} กลุ่ม</Badge>
            </Flex>
            {contentGroups.length === 0 ? (
              <Text color='gray.500'>ยังไม่มีกลุ่มเนื้อหา เนื้อหาที่ไม่เลือกกลุ่มจะยังแสดงเป็นเนื้อหาเดี่ยว</Text>
            ) : (
              <VStack align='stretch' spacing={3}>
                {contentGroups.map((group) => (
                  <Flex
                    key={group._id}
                    p={3}
                    borderWidth='1px'
                    borderRadius='md'
                    align={['stretch', 'center']}
                    direction={['column', 'row']}
                    justify='space-between'
                    gap={3}
                  >
                    <Box>
                      <HStack>
                        <Badge colorScheme='purple'>{group.index ?? 0}</Badge>
                        <Text fontWeight='bold'>{group.name}</Text>
                        <Badge colorScheme={group.status === 'public' ? 'green' : 'orange'}>
                          {group.status === 'public' ? 'เปิด' : 'ปิด'}
                        </Badge>
                        <Badge colorScheme={group.certificateconfig?.status ? 'green' : 'gray'}>
                          {group.certificateconfig?.status ? 'ออกใบได้' : 'ไม่ออกใบ'}
                        </Badge>
                      </HStack>
                      <Text fontSize='sm' color='gray.500'>
                        {group.description || '-'} · {group.contents?.length || 0} เนื้อหา
                      </Text>
                    </Box>
                    <HStack>
                      <Button size='sm' variant='outline' onClick={() => openEditContentGroupModal(group)}>
                        แก้ไข
                      </Button>
                      <Button size='sm' colorScheme='green' variant='outline' onClick={() => openContentGroupCertificateModal(group)}>
                        ตั้งค่าใบประกาศ
                      </Button>
                      <Button size='sm' colorScheme='red' variant='ghost' onClick={() => handleRemoveContentGroup(group._id)}>
                        ลบ
                      </Button>
                    </HStack>
                  </Flex>
                ))}
              </VStack>
            )}
          </Box>

          {loading ? (
            <Stack py={20}>
              <Skeleton height='20px' />
              <Skeleton height='20px' />
              <Skeleton height='20px' />
            </Stack>
          ) : (
            <Box
              sx={{ overflowX: ['auto', 'auto', 'none'], maxW: ['none'] }}
              boxShadow={'xl'}
              borderWidth={'1px'}
              mt={5}
            >
              <Table variant='simple'>
                <Thead>
                  <Tr bg={'gray.400'}>
                    {/* <Td textAlign="center" >{t('managecontentPage.number')}</Td> */}
                    <Td textAlign='center'>{t('managecontentPage.content')}</Td>
                    <Td textAlign='center'>{t('managecontentPage.type')}</Td>
                    <Td textAlign='center'>{t('managecontentPage.status')}</Td>
                    <Td textAlign='center'>Public</Td>
                    <Td textAlign='center'>Views</Td>
                    <Td textAlign='center'>{t('managecontentPage.manage')}</Td>
                  </Tr>
                </Thead>

                {contentState?.length != 0 && (
                  <Tbody>
                    {contentState?.map((content, i) => (
                      <Tr key={i}>
                        {/* {console.log(i)} */}
                        {/* <Td textAlign="center">{i + 1}</Td> */}
                        <Td textAlign='center' maxW={'30vh'}>
                          {/* {console.log("TEEEEE", content)} */}
                          <Link
                            mr={2}
                            onClick={(e) => {
                              e.preventDefault();
                              handlePreviewOpen(content?.type);
                              setUpdateContentData(content);
                              setPreview(content);
                              // console.log(content)
                            }}
                          >
                            {content?.name}
                          </Link>
                          <Text fontSize='xs' color='gray.500'>
                            กลุ่ม: {content?.contentGroup?.name || 'ไม่อยู่ในกลุ่ม'}
                          </Text>
                        </Td>
                        <Td textAlign='center'>{content?.type}</Td>
                        <Td textAlign='center' maxW={'100px'}>
                          <Center>
                            <Box w='100%' color='white'>
                              <Center>
                                {content?.statusActive ? (
                                  <Tag
                                    borderRadius='full'
                                    boxShadow={'lg'}
                                    variant='solid'
                                    colorScheme='green'
                                    w={'full'}
                                    py={1}
                                    justifyContent={'center'}
                                  >
                                    <TagLabel>{t('managecontentPage.public')}</TagLabel>
                                  </Tag>
                                ) : (
                                  <Tag
                                    borderRadius='full'
                                    boxShadow={'lg'}
                                    variant='solid'
                                    w={'full'}
                                    py={1}
                                    justifyContent={'center'}
                                  >
                                    <TagLabel>{t('managecontentPage.nonepublic')}</TagLabel>
                                  </Tag>
                                )}
                              </Center>
                            </Box>
                          </Center>
                        </Td>
                        <Td textAlign='center' maxW={'100px'}>
                          <Center>
                            {content?.public ? (
                              <Tag
                                borderRadius='full'
                                boxShadow={'lg'}
                                variant='solid'
                                colorScheme='blue'
                                w={'full'}
                                py={1}
                                justifyContent={'center'}
                              >
                                <TagLabel>{t('course.viewFree')}</TagLabel>
                              </Tag>
                            ) : (
                              <Tag
                                borderRadius='full'
                                boxShadow={'lg'}
                                variant='solid'
                                colorScheme='gray'
                                w={'full'}
                                py={1}
                                justifyContent={'center'}
                              >
                                <TagLabel>{t('course.close')}</TagLabel>
                              </Tag>
                            )}
                          </Center>
                        </Td>
                        <Td textAlign='center'>{content?.viewCount || 0}</Td>
                        <Td>
                          <Flex justify='end'>
                            {content?.type === 'homework' && (
                              <Tooltip label={t('managecontentPage.homeworkButton')} fontsize='md'>
                                <Button
                                  mr={2}
                                  boxShadow={'lg'}
                                  as={domlink}
                                  to={`homeworkdetail/${content?._id}/${param?.subjectId}`}
                                >
                                  <FaRegFile />
                                </Button>
                              </Tooltip>
                            )}
                            {/* {content?.type === 'link' && (
                                                            <Tooltip label={t('managecontentPage.homeworkButton')} fontsize="md">
                                                                <Button
                                                                    as={domlink}
                                                                    to={`${content?.link}`}
                                                                    mr={2}>
                                                                    <FaRegFile />
                                                                </Button>
                                                            </Tooltip>
                                                        )} */}
                            {content.type === 'quiz' ? (
                              <>
                                <Tooltip label={t('managecontentPage.quizButton')} fontsize='md'>
                                  <Button
                                    boxShadow={'lg'}
                                    as={domlink}
                                    to={`/managecontent/questions/${content?._id}`}
                                    mr={2}
                                  >
                                    <FaRegFile />
                                  </Button>
                                </Tooltip>
                                <Tooltip label={t('Button.edit')} fontsize='md'>
                                  <Button
                                    boxShadow={'lg'}
                                    mr={2}
                                    as={domlink}
                                    to={`/managecontent/managequestion/${content?._id}`}
                                  >
                                    <FaPencilAlt />
                                  </Button>
                                </Tooltip>
                              </>
                            ) : content?.type === 'survey' ? (
                              <>
                                <Tooltip label={t('managecontentPage.surveyButton')} fontsize='md'>
                                  <Button
                                    boxShadow={'lg'}
                                    mr={2}
                                    as={domlink}
                                    to={`/managecontent/surveys/${content?._id}`}
                                  >
                                    <FaRegFile />
                                  </Button>
                                </Tooltip>
                                <Tooltip label={t('Button.edit')} fontsize='md'>
                                  <Button
                                    boxShadow={'lg'}
                                    mr={2}
                                    as={domlink}
                                    to={`/managecontent/managesurvey/${content?._id}`}
                                  >
                                    <FaPencilAlt />
                                  </Button>
                                </Tooltip>
                              </>
                            ) : (
                              <Tooltip label={t('Button.edit')} fontsize='md'>
                                <Button
                                  mr={2}
                                  boxShadow={'lg'}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    modalUpdateContentOpen(content);
                                  }}
                                >
                                  <FaPencilAlt />
                                </Button>
                              </Tooltip>
                            )}

                            <Tooltip label={t('Button.delete')} fontsize='md'>
                              <Button
                                boxShadow={'lg'}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleOpenRemoveContent(content);
                                }}
                              >
                                <FaTrashAlt />
                              </Button>
                            </Tooltip>
                          </Flex>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                )}
              </Table>
              {contentState?.length == 0 && (
                <Box align='center' w={'full'} py={'20'} color={'gray.500'} bg={'gray.200'}>
                  <Heading>{t('managecontentPage.warningcontentempty')}</Heading>
                </Box>
              )}
            </Box>
          )}
        </Container>
      </Box>
      <DialogSortingContent
        isContentSorting={isContentSorting}
        onSortingClose={onSortingClose}
        contentState={contentState}
        sortingState={sortingState}
        setSortingState={setSortingState}
        setRefetchList={setRefetchList}
      />
    </Fragment>
  );
};

export default ManageContentPage;
